/**
 * A function to create a log object for the 'userLiveVideoParticipantsActionClickedSrc126Evid10' event (evid: 10)
 *
 * Event description: user event fired when user clicks on action on "three dots" button by the participant name
 *
 * @param {userLiveVideoParticipantsActionClickedSrc126Evid10Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @property {string} action - {"block_chat","remove_participant","mute","turn_off_camera","stop_screen_share"}
 * @return {LogObject<userLiveVideoParticipantsActionClickedSrc126Evid10Params>} LogObject<userLiveVideoParticipantsActionClickedSrc126Evid10Params>
 */
export function userLiveVideoParticipantsActionClickedSrc126Evid10(params) {
    return { evid: 10, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoSettingsOpened' event (evid: 12)
 *
 * Event description: user event fired when user opens settings by clicking on "Settings" button
 *
 * @param {userLiveVideoSettingsOpenedParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoSettingsOpenedParams>} LogObject<userLiveVideoSettingsOpenedParams>
 */
export function userLiveVideoSettingsOpened(params) {
    return { evid: 12, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoEndVideoClickSrc126Evid13' event (evid: 13)
 *
 * Event description: user event fired when user clicks "End Video" at "End Live Video" window
 *
 * @param {userLiveVideoEndVideoClickSrc126Evid13Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoEndVideoClickSrc126Evid13Params>} LogObject<userLiveVideoEndVideoClickSrc126Evid13Params>
 */
export function userLiveVideoEndVideoClickSrc126Evid13(params) {
    return { evid: 13, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoHostScreenLoadedSrc126Evid14' event (evid: 14)
 *
 * Event description: user event fired when user loads the host screen
 *
 * @param {userLiveVideoHostScreenLoadedSrc126Evid14Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoHostScreenLoadedSrc126Evid14Params>} LogObject<userLiveVideoHostScreenLoadedSrc126Evid14Params>
 */
export function userLiveVideoHostScreenLoadedSrc126Evid14(params) {
    return { evid: 14, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoStartRecordVideo' event (evid: 15)
 *
 * Event description: user event fired when video recording actually starts
 *
 * @param {userLiveVideoStartRecordVideoParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} recording_id - recording_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoStartRecordVideoParams>} LogObject<userLiveVideoStartRecordVideoParams>
 */
export function userLiveVideoStartRecordVideo(params) {
    return { evid: 15, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoStopRecordVideoSrc126Evid16' event (evid: 16)
 *
 * Event description: user event fired when video recording actually stops
 *
 * @param {userLiveVideoStopRecordVideoSrc126Evid16Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} recording_id - recording_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoStopRecordVideoSrc126Evid16Params>} LogObject<userLiveVideoStopRecordVideoSrc126Evid16Params>
 */
export function userLiveVideoStopRecordVideoSrc126Evid16(params) {
    return { evid: 16, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoStartVideoClickSrc126Evid17' event (evid: 17)
 *
 * Event description: user event fired when user starts video by clicking "Start Video" button
 *
 * @param {userLiveVideoStartVideoClickSrc126Evid17Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} parent_meeting_id - used for Video Test sessions to identify the meeting_id to which they are connected. NULL for non-video tests.
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoStartVideoClickSrc126Evid17Params>} LogObject<userLiveVideoStartVideoClickSrc126Evid17Params>
 */
export function userLiveVideoStartVideoClickSrc126Evid17(params) {
    return { evid: 17, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoMicrophoneToggleSrc126Evid18' event (evid: 18)
 *
 * Event description: user event fired when user toggles microphone button
 *
 * @param {uouLiveVideoMicrophoneToggleSrc126Evid18Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} origin - {"host_screen","meeting"}
 * @property {string} choice - {"on","off"}
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoMicrophoneToggleSrc126Evid18Params>} LogObject<uouLiveVideoMicrophoneToggleSrc126Evid18Params>
 */
export function uouLiveVideoMicrophoneToggleSrc126Evid18(params) {
    return { evid: 18, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoCameraToggleSrc126Evid19' event (evid: 19)
 *
 * Event description: user event fired when user toggles camera button
 *
 * @param {userLiveVideoCameraToggleSrc126Evid19Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} origin - {"host_screen","meeting"}
 * @property {string} choice - {"on","off"}
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoCameraToggleSrc126Evid19Params>} LogObject<userLiveVideoCameraToggleSrc126Evid19Params>
 */
export function userLiveVideoCameraToggleSrc126Evid19(params) {
    return { evid: 19, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoGivePermissionsClickSrc126Evid2' event (evid: 2)
 *
 * Event description: user event fired when user clicks "Give Permissions"
 *
 * @param {userLiveVideoGivePermissionsClickSrc126Evid2Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoGivePermissionsClickSrc126Evid2Params>} LogObject<userLiveVideoGivePermissionsClickSrc126Evid2Params>
 */
export function userLiveVideoGivePermissionsClickSrc126Evid2(params) {
    return { evid: 2, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoRecordingStartPopupOpened' event (evid: 20)
 *
 * Event description: user event fired when user clicks on "start recording" and sees a popup message to start recording
 *
 * @param {videoRecordingStartPopupOpenedParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<videoRecordingStartPopupOpenedParams>} LogObject<videoRecordingStartPopupOpenedParams>
 */
export function videoRecordingStartPopupOpened(params) {
    return { evid: 20, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoRecordingStopPopupOpened' event (evid: 21)
 *
 * Event description: user event fired when user clicks on "stop recording" and sees a popup message to start recording
 *
 * @param {videoRecordingStopPopupOpenedParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} recording_id - recording_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<videoRecordingStopPopupOpenedParams>} LogObject<videoRecordingStopPopupOpenedParams>
 */
export function videoRecordingStopPopupOpened(params) {
    return { evid: 21, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoRecordingStartConfirmationClick' event (evid: 22)
 *
 * Event description: user event fired when user clicks on confirmation to start recording after popup.
 *
 * @param {videoRecordingStartConfirmationClickParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} origin - {'failed_recording',null}
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<videoRecordingStartConfirmationClickParams>} LogObject<videoRecordingStartConfirmationClickParams>
 */
export function videoRecordingStartConfirmationClick(params) {
    return { evid: 22, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoRecordingStopConfirmationClick' event (evid: 23)
 *
 * Event description: user event fired when user clicks on confirmation to stop recording after popup
 *
 * @param {videoRecordingStopConfirmationClickParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} recording_id - recording_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<videoRecordingStopConfirmationClickParams>} LogObject<videoRecordingStopConfirmationClickParams>
 */
export function videoRecordingStopConfirmationClick(params) {
    return { evid: 23, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'manageRecordingsPageView' event (evid: 24)
 *
 * Event description: user opens "manage recordings" page
 *
 * @param {manageRecordingsPageViewParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<manageRecordingsPageViewParams>} LogObject<manageRecordingsPageViewParams>
 */
export function manageRecordingsPageView(params) {
    return { evid: 24, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoRecordingDownloadClick' event (evid: 25)
 *
 * Event description: user clicks download video recording
 *
 * @param {videoRecordingDownloadClickParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} recording_id - recording_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<videoRecordingDownloadClickParams>} LogObject<videoRecordingDownloadClickParams>
 */
export function videoRecordingDownloadClick(params) {
    return { evid: 25, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoRecordingDeleteClick' event (evid: 26)
 *
 * Event description: user clicks delete video recording
 *
 * @param {videoRecordingDeleteClickParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} recording_id - recording_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<videoRecordingDeleteClickParams>} LogObject<videoRecordingDeleteClickParams>
 */
export function videoRecordingDeleteClick(params) {
    return { evid: 26, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'usersStartTestClick' event (evid: 27)
 *
 * Event description: User clicks the 'Test Video' button
 *
 * @param {usersStartTestClickParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} entity_name - entity name
 * @property {string} entity_id - entity_id
 * @property {string} parent_meeting_id - parent_meeting_id
 * @property {string} meeting_id - metting_id
 * @return {LogObject<usersStartTestClickParams>} LogObject<usersStartTestClickParams>
 */
export function usersStartTestClick(params) {
    return { evid: 27, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userCopyJoinLink' event (evid: 28)
 *
 * Event description: user event fires when user clicks on the "copy private join link" text to copy the shareable link
 *
 * @param {userCopyJoinLinkParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userCopyJoinLinkParams>} LogObject<userCopyJoinLinkParams>
 */
export function userCopyJoinLink(params) {
    return { evid: 28, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userBannerClick' event (evid: 29)
 *
 * Event description: Users clicks on one of the available banners for WixLive
 *
 * @param {userBannerClickParams} params - The parameters for this event
 * @property {string} banner_name - {'premium_upgrade'}
 * @property {string} origin - banner's location: {'live_video_tab'}
 * @property {GUID} msid - msid
 * @return {LogObject<userBannerClickParams>} LogObject<userBannerClickParams>
 */
export function userBannerClick(params) {
    return { evid: 29, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoShareScreenToggleSrc126Evid3' event (evid: 3)
 *
 * Event description: user event fired when user toggles screen share icon
 *
 * @param {userLiveVideoShareScreenToggleSrc126Evid3Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} origin - {"host_screen","meeting"}
 * @property {string} choice - {"on","off"}
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoShareScreenToggleSrc126Evid3Params>} LogObject<userLiveVideoShareScreenToggleSrc126Evid3Params>
 */
export function userLiveVideoShareScreenToggleSrc126Evid3(params) {
    return { evid: 3, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoRecordingForceEndedPopupShown' event (evid: 30)
 *
 * Event description: user event fired when recoding is force stopped not by user
 *
 * @param {videoRecordingForceEndedPopupShownParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} recording_id - recording_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<videoRecordingForceEndedPopupShownParams>} LogObject<videoRecordingForceEndedPopupShownParams>
 */
export function videoRecordingForceEndedPopupShown(params) {
    return { evid: 30, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'videoRecordingFailedPopup' event (evid: 31)
 *
 * Event description: User receives a popup upon failing to start a recording of a WixLive session
 *
 * @param {videoRecordingFailedPopupParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<videoRecordingFailedPopupParams>} LogObject<videoRecordingFailedPopupParams>
 */
export function videoRecordingFailedPopup(params) {
    return { evid: 31, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardActionClick' event (evid: 32)
 *
 * Event description: User clicks one of the available actions for either upcoming or past broadcasts from the Live Video dashboard
 *
 * @param {dashboardActionClickParams} params - The parameters for this event
 * @property {string} action_name - {'manage','edit_event','change_video_type','view_details'}
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} origin - {'upcoming','past'}
 * @property {string} meeting_id - meeting id
 * @return {LogObject<dashboardActionClickParams>} LogObject<dashboardActionClickParams>
 */
export function dashboardActionClick(params) {
    return { evid: 32, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userClickThreeDotsOneapp' event (evid: 33)
 *
 * Event description: When host (user) clicks on three dots inside live video session from oneapp
 *
 * @param {userClickThreeDotsOneappParams} params - The parameters for this event
 * @property {string} video_conferencing_type - video_conferencing_type
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userClickThreeDotsOneappParams>} LogObject<userClickThreeDotsOneappParams>
 */
export function userClickThreeDotsOneapp(params) {
    return { evid: 33, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoChangeLayoutClickSrc126Evid4' event (evid: 4)
 *
 * Event description: user event fired when user toggles layout button
 *
 * @param {userLiveVideoChangeLayoutClickSrc126Evid4Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} origin - {"host_screen","meeting"}
 * @property {string} choice - {"speaker","grid"}
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoChangeLayoutClickSrc126Evid4Params>} LogObject<userLiveVideoChangeLayoutClickSrc126Evid4Params>
 */
export function userLiveVideoChangeLayoutClickSrc126Evid4(params) {
    return { evid: 4, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoChatOpenedSrc126Evid5' event (evid: 5)
 *
 * Event description: user event fired when user toggles layout user event fired when user opens chat by clicking "Chat" button
 *
 * @param {userLiveVideoChatOpenedSrc126Evid5Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} choice - {"on","off"}
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoChatOpenedSrc126Evid5Params>} LogObject<userLiveVideoChatOpenedSrc126Evid5Params>
 */
export function userLiveVideoChatOpenedSrc126Evid5(params) {
    return { evid: 5, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoJoinClick' event (evid: 501)
 *
 * Event description: fired when uou clicked "join meeting" or "join webinar" button
 *
 * @param {uouLiveVideoJoinClickParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} participant_id - participant_id
 * @property {GUID} app_id - app_id
 * @property {boolean} is_preview - true if the action is performed through the preview
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoJoinClickParams>} LogObject<uouLiveVideoJoinClickParams>
 */
export function uouLiveVideoJoinClick(params) {
    return { evid: 501, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoWaittingScreenLoadedSrc126Evid502' event (evid: 502)
 *
 * Event description: uou event fired after waiting screen loaded
 *
 * @param {uouLiveVideoWaittingScreenLoadedSrc126Evid502Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} participant_id - participant_id
 * @property {GUID} app_id - app_id
 * @property {boolean} is_preview - true if the action is performed through the preview
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoWaittingScreenLoadedSrc126Evid502Params>} LogObject<uouLiveVideoWaittingScreenLoadedSrc126Evid502Params>
 */
export function uouLiveVideoWaittingScreenLoadedSrc126Evid502(params) {
    return { evid: 502, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoMicrophoneToggleSrc126Evid503' event (evid: 503)
 *
 * Event description: uou event fired when microphone mute unmute button clicked while either being in waiting room or during meeting
 *
 * @param {uouLiveVideoMicrophoneToggleSrc126Evid503Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} origin - {"waiting_room", "meeting"}
 * @property {string} choice - {"on","off"}
 * @property {GUID} app_id - app_id
 * @property {boolean} is_preview - true if the action is performed through the preview
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoMicrophoneToggleSrc126Evid503Params>} LogObject<uouLiveVideoMicrophoneToggleSrc126Evid503Params>
 */
export function uouLiveVideoMicrophoneToggleSrc126Evid503(params) {
    return { evid: 503, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoCameraToggle' event (evid: 504)
 *
 * Event description: uou event fired when camera on/off button clicked while either being in waiting room or during the meeting
 *
 * @param {uouLiveVideoCameraToggleParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} origin - {"waiting_room", "meeting"}
 * @property {string} choice - {"on","off"}
 * @property {GUID} app_id - app_id
 * @property {boolean} is_preview - true if the action is performed through the preview
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoCameraToggleParams>} LogObject<uouLiveVideoCameraToggleParams>
 */
export function uouLiveVideoCameraToggle(params) {
    return { evid: 504, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoChangeLayoutSrc126Evid505' event (evid: 505)
 *
 * Event description: uou event fired when uou changes layout to grid or speaker view.
 *
 * @param {uouLiveVideoChangeLayoutSrc126Evid505Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} layout_type - {"speaker","grid"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoChangeLayoutSrc126Evid505Params>} LogObject<uouLiveVideoChangeLayoutSrc126Evid505Params>
 */
export function uouLiveVideoChangeLayoutSrc126Evid505(params) {
    return { evid: 505, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoChatMessagePublishSrc126Evid506' event (evid: 506)
 *
 * Event description: uou event fired when uou send a message to the chat
 *
 * @param {uouLiveVideoChatMessagePublishSrc126Evid506Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoChatMessagePublishSrc126Evid506Params>} LogObject<uouLiveVideoChatMessagePublishSrc126Evid506Params>
 */
export function uouLiveVideoChatMessagePublishSrc126Evid506(params) {
    return { evid: 506, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoChatScreenToggleSrc126Evid507' event (evid: 507)
 *
 * Event description: uou event fired when uou toggle chat on/off using chat toggle button or close chat button
 *
 * @param {uouLiveVideoChatScreenToggleSrc126Evid507Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} choice - {"on","off"}
 * @property {GUID} app_id - app_id
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoChatScreenToggleSrc126Evid507Params>} LogObject<uouLiveVideoChatScreenToggleSrc126Evid507Params>
 */
export function uouLiveVideoChatScreenToggleSrc126Evid507(params) {
    return { evid: 507, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoReactionPublish' event (evid: 508)
 *
 * Event description: uou event fired when uou clicks on reaction
 *
 * @param {uouLiveVideoReactionPublishParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoReactionPublishParams>} LogObject<uouLiveVideoReactionPublishParams>
 */
export function uouLiveVideoReactionPublish(params) {
    return { evid: 508, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoSettingsToggleSrc126Evid509' event (evid: 509)
 *
 * Event description: uou event fired each time when uou open/close settings using settings toggle button or settings close window button
 *
 * @param {uouLiveVideoSettingsToggleSrc126Evid509Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} choice - {"on","off"}
 * @property {GUID} app_id - app_id
 * @property {boolean} is_preview - true if the action is performed through the preview
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoSettingsToggleSrc126Evid509Params>} LogObject<uouLiveVideoSettingsToggleSrc126Evid509Params>
 */
export function uouLiveVideoSettingsToggleSrc126Evid509(params) {
    return { evid: 509, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoShareScreenToggleSrc126Evid510' event (evid: 510)
 *
 * Event description: uou event fired when uou starts or stops screen sharing by either using screen sharing toggle button or "stop sharing" button
 *
 * @param {uouLiveVideoShareScreenToggleSrc126Evid510Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} choice - {"on","off"}
 * @property {GUID} app_id - app_id
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoShareScreenToggleSrc126Evid510Params>} LogObject<uouLiveVideoShareScreenToggleSrc126Evid510Params>
 */
export function uouLiveVideoShareScreenToggleSrc126Evid510(params) {
    return { evid: 510, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoLeaveClickSrc126Evid511' event (evid: 511)
 *
 * Event description: uou event fired when uou leaves meeting by clicking "leave" button
 *
 * @param {uouLiveVideoLeaveClickSrc126Evid511Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} participant_id - participant_id
 * @property {GUID} app_id - app_id
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoLeaveClickSrc126Evid511Params>} LogObject<uouLiveVideoLeaveClickSrc126Evid511Params>
 */
export function uouLiveVideoLeaveClickSrc126Evid511(params) {
    return { evid: 511, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoParticipantsListToggleSrc126Evid512' event (evid: 512)
 *
 * Event description: uou event fired when uou toggles participant list icon or close participants list with close button
 *
 * @param {uouLiveVideoParticipantsListToggleSrc126Evid512Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {string} choice - {"on","off"}
 * @property {GUID} app_id - app_id
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoParticipantsListToggleSrc126Evid512Params>} LogObject<uouLiveVideoParticipantsListToggleSrc126Evid512Params>
 */
export function uouLiveVideoParticipantsListToggleSrc126Evid512(params) {
    return { evid: 512, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoExitScreenLoaded' event (evid: 513)
 *
 * Event description: uoo event fired when exit screen is loaded after either uou leaving the video by himself, video meeting/webinar ending or uou got banned
 *
 * @param {uouLiveVideoExitScreenLoadedParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} reason - {"end","leave","banned"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} participant_id - participant_id
 * @property {GUID} app_id - app_id
 * @property {boolean} is_preview - true if the action is performed through the preview
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoExitScreenLoadedParams>} LogObject<uouLiveVideoExitScreenLoadedParams>
 */
export function uouLiveVideoExitScreenLoaded(params) {
    return { evid: 513, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoGoToSiteClickSrc126Evid514' event (evid: 514)
 *
 * Event description: uoo event fired when uou clicks on "go to site" from exit screen
 *
 * @param {uouLiveVideoGoToSiteClickSrc126Evid514Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoGoToSiteClickSrc126Evid514Params>} LogObject<uouLiveVideoGoToSiteClickSrc126Evid514Params>
 */
export function uouLiveVideoGoToSiteClickSrc126Evid514(params) {
    return { evid: 514, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoRejoinClickSrc126Evid515' event (evid: 515)
 *
 * Event description: uoo event fired when uou clicks "rejoin" from exit screen
 *
 * @param {uouLiveVideoRejoinClickSrc126Evid515Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {string} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} participant_id - participant_id
 * @property {GUID} app_id - app_id
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<uouLiveVideoRejoinClickSrc126Evid515Params>} LogObject<uouLiveVideoRejoinClickSrc126Evid515Params>
 */
export function uouLiveVideoRejoinClickSrc126Evid515(params) {
    return { evid: 515, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoChatMessagePublishSrc126Evid6' event (evid: 6)
 *
 * Event description: user event fired when user sends a message in the chat
 *
 * @param {userLiveVideoChatMessagePublishSrc126Evid6Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoChatMessagePublishSrc126Evid6Params>} LogObject<userLiveVideoChatMessagePublishSrc126Evid6Params>
 */
export function userLiveVideoChatMessagePublishSrc126Evid6(params) {
    return { evid: 6, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoChatActionClickedSrc126Evid7' event (evid: 7)
 *
 * Event description: user event fired when user clicks on action on "three dots" button by the message
 *
 * @param {userLiveVideoChatActionClickedSrc126Evid7Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @property {string} action - {"highlight","remove_highlight","block_user","delete_message"}
 * @return {LogObject<userLiveVideoChatActionClickedSrc126Evid7Params>} LogObject<userLiveVideoChatActionClickedSrc126Evid7Params>
 */
export function userLiveVideoChatActionClickedSrc126Evid7(params) {
    return { evid: 7, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sessionDurations' event (evid: 701)
 *
 * Event description: Duration for live video meeting, participant, participant video
 *
 * @param {sessionDurationsParams} params - The parameters for this event
 * @property {GUID} external_attendee_id - external_attendee_id
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {number} duration - duration
 * @property {GUID} external_meeting_id - external_meeting_id
 * @property {string} duration_type - duration_type
 * @property {DateTime} end_timestamp - end_timestamp
 * @property {GUID} visitor_id - visitor_id
 * @property {string} entity_type - entity_type
 * @property {string} live_session_id - live_session_id
 * @property {DateTime} start_timestamp - start_timestamp
 * @property {string} entity_id - entity_id
 * @property {GUID} wix_app_id - wix_app_id
 * @property {GUID} participant_id - participant_id
 * @property {boolean} is_test_call - is_test_call
 * @return {LogObject<sessionDurationsParams>} LogObject<sessionDurationsParams>
 */
export function sessionDurations(params) {
    return { evid: 701, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoReactionsOpenedSrc126Evid8' event (evid: 8)
 *
 * Event description: user event fired when user opens reactions by clicking "Reactions" button
 *
 * @param {userLiveVideoReactionsOpenedSrc126Evid8Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoReactionsOpenedSrc126Evid8Params>} LogObject<userLiveVideoReactionsOpenedSrc126Evid8Params>
 */
export function userLiveVideoReactionsOpenedSrc126Evid8(params) {
    return { evid: 8, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoParticipantsListOpenedSrc126Evid9' event (evid: 9)
 *
 * Event description: user event fired when user opens participants list by clicking "Participants" button
 *
 * @param {userLiveVideoParticipantsListOpenedSrc126Evid9Params} params - The parameters for this event
 * @property {string} video_conferencing_type - {"meeting","stream"}
 * @property {GUID} app_instance_id - app_instance_id
 * @property {string} entity_name - entity_name
 * @property {string} entity_id - entity_id
 * @property {GUID} app_id - app_id
 * @property {string} msid - msid
 * @property {string} meeting_id - meeting_id
 * @return {LogObject<userLiveVideoParticipantsListOpenedSrc126Evid9Params>} LogObject<userLiveVideoParticipantsListOpenedSrc126Evid9Params>
 */
export function userLiveVideoParticipantsListOpenedSrc126Evid9(params) {
    return { evid: 9, src: 126, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingMapSavedFrom' event (evid: 101)
 *
 * Event description: fired when seating map is updated, saved, deleted
 *
 * @param {seatingMapSavedFromParams} params - The parameters for this event
 * @property {GUID} seating_map_id - seating_map_id
 * @property {string} actiontype - actiontype
 * @property {GUID} meta_site_id - meta_site_id
 * @property {string} external_id - event guid
 * @property {string} action_type - UPDATE, SAVE, DELETE
 * @return {LogObject<seatingMapSavedFromParams>} LogObject<seatingMapSavedFromParams>
 */
export function seatingMapSavedFrom(params) {
    return { evid: 101, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyNameSrc148Evid200' event (evid: 200)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameSrc148Evid200Params} params - The parameters for this event
 * @return {LogObject<dummyNameSrc148Evid200Params>} LogObject<dummyNameSrc148Evid200Params>
 */
export function dummyNameSrc148Evid200(params) {
    return { evid: 200, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'toolSidebarElementSelected' event (evid: 201)
 *
 * Event description: User selects of the available elements in the sidebar
 *
 * @param {toolSidebarElementSelectedParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} external_id - external_id
 * @property {string} element_type - {'rows','rectangular_table','round_table','area','text','rectangle','circle','line','icons'}
 * @return {LogObject<toolSidebarElementSelectedParams>} LogObject<toolSidebarElementSelectedParams>
 */
export function toolSidebarElementSelected(params) {
    return { evid: 201, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'elementDeleted' event (evid: 202)
 *
 * Event description: User deletes one  or multiple elements on the map
 *
 * @param {elementDeletedParams} params - The parameters for this event
 * @property {boolean} isMultiSelect - more than one element is selected
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} element_guid - element_guid or list of guids
 * @property {string} origin - {'stage','keyboard'}
 * @property {string} external_id - external_id
 * @property {string} element_type - {'multi_row','rows','rectangular_table','round_table','area','text','rectangle','circle','line','icons','multiple'}
 * @return {LogObject<elementDeletedParams>} LogObject<elementDeletedParams>
 */
export function elementDeleted(params) {
    return { evid: 202, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'elementEditSuccess' event (evid: 203)
 *
 * Event description: element_edit_success.
 *
 * @param {elementEditSuccessParams} params - The parameters for this event
 * @property {boolean} isMultiSelect - more than one element is selected
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} element_guid - element_guid or list of ids
 * @property {string} origin - {'inspector','stage','commands'}
 * @property {string} external_id - external_id
 * @property {string} element_type - element_type
 * @property {string} field_name - list of attributes changed during the edit {'number_of_seats','spacing','rotate','label','label_position','label_format','label_start_from,'label_direction','section_name','venue_name'}
 * @property {string} parameters - parameters
 * @return {LogObject<elementEditSuccessParams>} LogObject<elementEditSuccessParams>
 */
export function elementEditSuccess(params) {
    return { evid: 203, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mapElementSelected' event (evid: 204)
 *
 * Event description: User selects one or multiple elements on the map
 *
 * @param {mapElementSelectedParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating map guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} element_guid - element guid or list of ids
 * @property {string} external_id - external_id
 * @property {string} element_type - element_type
 * @property {number} elements_count - elements count
 *
 * @property {string} selection_mode - "Selection" or "Seat selection"
 * @property {boolean} is_subelement - is subelement
 * @return {LogObject<mapElementSelectedParams>} LogObject<mapElementSelectedParams>
 */
export function mapElementSelected(params) {
    return { evid: 204, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modeToolbarClick' event (evid: 205)
 *
 * Event description: Users uses one of the available tools in the mode toolbar
 *
 * @param {modeToolbarClickParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating map guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} button_name - {'selection','pan','seat selection'}
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} external_id - external_id
 * @property {string} origin - origin
 * @return {LogObject<modeToolbarClickParams>} LogObject<modeToolbarClickParams>
 */
export function modeToolbarClick(params) {
    return { evid: 205, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingMapSaveSuccess' event (evid: 206)
 *
 * Event description: User successfully saves/commits the changes in the map
 *
 * @param {seatingMapSaveSuccessParams} params - The parameters for this event
 * @property {number} capacity_with_tickets_count - total number of seats with tickets assigned
 * @property {number} capacity_count - total number of seats
 * @property {GUID} seating_map_guid - seating map guid
 * @property {GUID} app_def_id - app_def_id
 * @property {number} seats_elements_with_tickets_count - total number of seats elements with tickets assigned
 * @property {number} object_count - total number of objects on the map
 * @property {number} seats_elements_with_whole_table - total number of tables with whole table reservation enabled
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {number} seats_elements_count - total number of seats element
 * @property {string} external_id - external_id
 * @property {number} total_capacity_with_whole_table - total number of seats with whole table reservation enabled
 * @return {LogObject<seatingMapSaveSuccessParams>} LogObject<seatingMapSaveSuccessParams>
 */
export function seatingMapSaveSuccess(params) {
    return { evid: 206, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modalTrigger' event (evid: 207)
 *
 * Event description: User receives one of the modals available in the builder
 *
 * @param {modalTriggerParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating map guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} modal_name - {'preview','ticket_delete','continue_where_left_off','venue_name')
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} external_id - external_id
 * @property {string} reason_modal_was_triggered - Reason what kind of action triggered the modal. If possible and necessary.
 * @return {LogObject<modalTriggerParams>} LogObject<modalTriggerParams>
 */
export function modalTrigger(params) {
    return { evid: 207, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'navigationClick' event (evid: 208)
 *
 * Event description: user clicks one of the navigation buttons available
 *
 * @param {navigationClickParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} button_name - {'back_to_dashboard'}
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} external_id - external_id
 * @return {LogObject<navigationClickParams>} LogObject<navigationClickParams>
 */
export function navigationClick(params) {
    return { evid: 208, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'backgroundChangeSuccess' event (evid: 209)
 *
 * Event description: User makes a change to the background color of the seating map and confirms the change (change in color requires a confirmation)
 *
 * @param {backgroundChangeSuccessParams} params - The parameters for this event
 * @property {string} parameter - {'color','opacity'}
 * @property {GUID} seating_map_guid - seating map id
 * @property {GUID} app_def_id - app_def_id
 * @property {boolean} is_custom - true if user selects a color from the picker instead of the swatches
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} external_id - external_id
 * @property {string} value - relevant value of the parameter: #RGB color, percentile for opacity
 * @return {LogObject<backgroundChangeSuccessParams>} LogObject<backgroundChangeSuccessParams>
 */
export function backgroundChangeSuccess(params) {
    return { evid: 209, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mapTabOpened' event (evid: 210)
 *
 * Event description: users switches between the tabs inside the builder. Lack of last_tab_name indicates the builder being opened
 *
 * @param {mapTabOpenedParams} params - The parameters for this event
 * @property {string} tab_name - {'map_design',''assign_tickets}
 * @property {string} last_tab_name - same as tab_name; null if user just arrives in the builder
 * @property {GUID} seating_map_guid - seating map id
 * @property {GUID} app_def_id - app_def_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} external_id - external_id
 * @return {LogObject<mapTabOpenedParams>} LogObject<mapTabOpenedParams>
 */
export function mapTabOpened(params) {
    return { evid: 210, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modalSelectionConfirmationSrc148Evid211' event (evid: 211)
 *
 * Event description: User clicks one of the buttons available on the pop'ed modal
 *
 * @param {modalSelectionConfirmationSrc148Evid211Params} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} button_name - {'save','delete','cancel','x','continue','restore'}
 * @property {string} modal_name - {'save_changes','save_map_design','ticket_delete','continue_where_left_off','edit_venue_name'}
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} external_id - external_id
 * @return {LogObject<modalSelectionConfirmationSrc148Evid211Params>} LogObject<modalSelectionConfirmationSrc148Evid211Params>
 */
export function modalSelectionConfirmationSrc148Evid211(params) {
    return { evid: 211, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'elementAdded' event (evid: 212)
 *
 * Event description: element_added.
 *
 * @param {elementAddedParams} params - The parameters for this event
 * @property {boolean} isMultiSelect - true if the edit is made while selecting several elements
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} duplicated_from - list of element _guids from which the duplicates were created
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} element_guid - element_guid
 * @property {string} origin - {'tool_sidebar','commands','duplicated'}
 * @property {string} external_id - external_id
 * @property {string} element_type - {'rows','rectangular_table','round_table','area','text','rectangle','circle','line','icons'}
 * @property {string} parameters - JSON format of: {key1:value1, key2:value2}. e.g {number_of_seats:50, label_direction:right, label:Q42}. Null if created by multiselect duplication
 * @return {LogObject<elementAddedParams>} LogObject<elementAddedParams>
 */
export function elementAdded(params) {
    return { evid: 212, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketAssignmentAction' event (evid: 213)
 *
 * Event description: User assigns or unassigns tickets fro map elements. Deleting a ticket sends out
 *
 * @param {ticketAssignmentActionParams} params - The parameters for this event
 * @property {boolean} isMultiSelect - more than one element is selected
 * @property {GUID} category_external_id - category_external_id (ticket def id for events)
 * @property {GUID} seating_map_guid - seating map guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} category_external_id_fqdn - category_external_id_fqdn (ticket def for events)
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} element_guid - element guid or list of ids to which the ticket was assigned
 * @property {string} external_id - external_id
 * @property {string} action - {'assign','unassign'}
 * @return {LogObject<ticketAssignmentActionParams>} LogObject<ticketAssignmentActionParams>
 */
export function ticketAssignmentAction(params) {
    return { evid: 213, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'navBarClick' event (evid: 214)
 *
 * Event description: undo_redo_click.
 *
 * @param {navBarClickParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} button_name - {'undo','redo'}
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} origin - {'nav_bar_click','keyboard'}
 * @property {string} external_id - external_id
 * @return {LogObject<navBarClickParams>} LogObject<navBarClickParams>
 */
export function navBarClick(params) {
    return { evid: 214, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'learnMoreClick' event (evid: 215)
 *
 * Event description: User clicks one of the available Learn More links
 *
 * @param {learnMoreClickParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} origin - origin
 * @property {string} external_id - external_id
 * @return {LogObject<learnMoreClickParams>} LogObject<learnMoreClickParams>
 */
export function learnMoreClick(params) {
    return { evid: 215, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'onboardingActionClick' event (evid: 216)
 *
 * Event description: User clicks one of the available buttons/actions in the onboarding modal
 *
 * @param {onboardingActionClickParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating map id
 * @property {GUID} app_def_id - app_def_id
 * @property {string} page_id - indicator for which of the 3 onboarding modal pages the button was clicked from
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} external_id - external_id
 * @property {string} action - {'learn_more','next','x','done'}
 * @return {LogObject<onboardingActionClickParams>} LogObject<onboardingActionClickParams>
 */
export function onboardingActionClick(params) {
    return { evid: 216, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingsMapBuilderClickSrc148Evid217' event (evid: 217)
 *
 * Event description: Generics clicks in the seatings map builder
 *
 * @param {seatingsMapBuilderClickSrc148Evid217Params} params - The parameters for this event
 * @property {string} external_id - external_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} origin - origin
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {string} action - action
 * @return {LogObject<seatingsMapBuilderClickSrc148Evid217Params>} LogObject<seatingsMapBuilderClickSrc148Evid217Params>
 */
export function seatingsMapBuilderClickSrc148Evid217(params) {
    return { evid: 217, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingsMapBuilderKeyboardShortcutUsedSrc148Evid218' event (evid: 218)
 *
 * Event description: User used a keyboard shortcut in seatings map builder
 *
 * @param {seatingsMapBuilderKeyboardShortcutUsedSrc148Evid218Params} params - The parameters for this event
 * @property {string} external_id - external_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} shortcut_name - shortcut_name
 * @property {GUID} seating_map_guid - seating_map_guid
 * @return {LogObject<seatingsMapBuilderKeyboardShortcutUsedSrc148Evid218Params>} LogObject<seatingsMapBuilderKeyboardShortcutUsedSrc148Evid218Params>
 */
export function seatingsMapBuilderKeyboardShortcutUsedSrc148Evid218(params) {
    return { evid: 218, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'objectSettingsChangedSrc148Evid221' event (evid: 221)
 *
 * Event description: Object settings cha
 *
 * @param {objectSettingsChangedSrc148Evid221Params} params - The parameters for this event
 * @property {string} field_name - field_name
 * @property {string} value - value
 * @property {string} old_value - old_value
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} app_def_id - app_def_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} external_id - external_id
 * @property {number} elements_count - elements_count
 * @property {string} object_types - object_types
 * @property {boolean} is_subelement - is_subelement
 * @return {LogObject<objectSettingsChangedSrc148Evid221Params>} LogObject<objectSettingsChangedSrc148Evid221Params>
 */
export function objectSettingsChangedSrc148Evid221(params) {
    return { evid: 221, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'elementManipulatedWithMouseSrc148Evid222' event (evid: 222)
 *
 * Event description: Element manipulated with mouse
 *
 *
 * @param {elementManipulatedWithMouseSrc148Evid222Params} params - The parameters for this event
 * @property {string} action - move, resize, draw, rotate, etc
 * @property {GUID} app_def_id - app_def_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {string} external_id - external_id
 * @property {number} elements_count - elements_count
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {boolean} is_subelement - is_subelement
 * @return {LogObject<elementManipulatedWithMouseSrc148Evid222Params>} LogObject<elementManipulatedWithMouseSrc148Evid222Params>
 */
export function elementManipulatedWithMouseSrc148Evid222(params) {
    return { evid: 222, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingsElementsGroupedSrc148Evid223' event (evid: 223)
 *
 * Event description: Multiple seatings elements grouped or ungrouped
 *
 * @param {seatingsElementsGroupedSrc148Evid223Params} params - The parameters for this event
 * @property {string} external_id - external_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {boolean} grouped - If it was grouped or ungrouped
 * @property {number} elements_count - affected elements count
 * @property {number} group_count - affected groups count
 * @return {LogObject<seatingsElementsGroupedSrc148Evid223Params>} LogObject<seatingsElementsGroupedSrc148Evid223Params>
 */
export function seatingsElementsGroupedSrc148Evid223(params) {
    return { evid: 223, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingsSoldOutElementHoveredSrc148Evid224' event (evid: 224)
 *
 * Event description: BI event indicating that user hovered on sold out seat
 *
 * @param {seatingsSoldOutElementHoveredSrc148Evid224Params} params - The parameters for this event
 * @property {string} external_id - external_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {string} element_type - TABLE, ROUND_TABLE AREA , ROW, MULTI_ROW or anything else
 * @return {LogObject<seatingsSoldOutElementHoveredSrc148Evid224Params>} LogObject<seatingsSoldOutElementHoveredSrc148Evid224Params>
 */
export function seatingsSoldOutElementHoveredSrc148Evid224(params) {
    return { evid: 224, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingsBuilderLoadDurationSrc148Evid225' event (evid: 225)
 *
 * Event description: Time it takes to load the seatings builder
 *
 * @param {seatingsBuilderLoadDurationSrc148Evid225Params} params - The parameters for this event
 * @property {string} external_id - external_id
 * @property {string} external_id_fqdn - external_id_fqdn
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {number} duration - number in miliseconds
 * @property {string} url_path - url_path
 * @return {LogObject<seatingsBuilderLoadDurationSrc148Evid225Params>} LogObject<seatingsBuilderLoadDurationSrc148Evid225Params>
 */
export function seatingsBuilderLoadDurationSrc148Evid225(params) {
    return { evid: 225, src: 148, endpoint: '', params };
}
/**
 * A function to create a log object for the 'documentTemplateSaved' event (evid: 6201)
 *
 * Event description: Fired when a document template is saved, edited or deleted
 *
 * @param {documentTemplateSavedParams} params - The parameters for this event
 * @property {DateTime} created_date - created_date
 * @property {string} template_type - template_type
 * @property {GUID} meta_site_id - meta_site_id
 * @property {string} paper_size - paper_size
 * @property {string} setting_groups - setting_groups
 * @property {GUID} template_settings_id - template_settings_id
 * @property {string} external_id - external_id
 * @property {string} app_slug - app_slug
 * @property {string} action - save, edit, delete
 * @property {string} template_id - template_id
 * @return {LogObject<documentTemplateSavedParams>} LogObject<documentTemplateSavedParams>
 */
export function documentTemplateSaved(params) {
    return { evid: 6201, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'expressCheckoutWidgetLoaded' event (evid: 1)
 *
 * Event description: express checkout widget loaded
 *
 * @param {expressCheckoutWidgetLoadedParams} params - The parameters for this event
 * @property {string} visible_express_checkout_buttons - 0,1,2,3
 * @return {LogObject<expressCheckoutWidgetLoadedParams>} LogObject<expressCheckoutWidgetLoadedParams>
 */
export function expressCheckoutWidgetLoaded(params) {
    return { evid: 1, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsPanelOpened' event (evid: 100)
 *
 * Event description: Settings Panel loaded
 * (previously 68/12, switched on April 03, 2017)
 * Should be sent with the permanent msid.
 * Save the ACTUAL loading_time and send it.
 *
 * @param {settingsPanelOpenedParams} params - The parameters for this event
 * @property {string} editor_view_mode - {'mobile', 'desktop'}
 * @property {string} origin - {'main_page', 'details_page', 'registration_page'}
 * @property {string} comp_id - comp_id
 * @property {GUID} instance_id - instance_id
 * @property {number} loading_time - loading time in ms
 * @return {LogObject<settingsPanelOpenedParams>} LogObject<settingsPanelOpenedParams>
 */
export function settingsPanelOpened(params) {
    return { evid: 100, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitRsvpSuccess' event (evid: 1002)
 *
 * Event description: success event of submit rsvp click by site guest
 *
 * @param {submitRsvpSuccessParams} params - The parameters for this event
 * @property {number} total_guests_count - total rsvps so far
 * @property {GUID} visitorId - visitor_id
 * @property {number} waiting_list_guest_count - waiting_list_guest_count
 * @property {GUID} uuid - uuid being sent when UoU is an actual Wix user
 * @property {number} confirmed_guests_count - confirmed_guests_count
 * @property {boolean} is_demo_data - is_demo_data
 * @property {number} event_capacity - event_capacity
 * @property {number} questions_count - questions_count
 * @property {string} event_name - event_name
 * @property {GUID} rsvp_id - rsvp_id
 * @property {number} event_rank - event_rank
 * @property {DateTime} event_start_date - event_start_date
 * @property {number} visitor_rsvp_count - 1 is the visitor have responded for himself, 2 or more if the user choose 'plus one' option
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {number} declined_guests_count - declined_guests_count
 * @property {GUID} event_id - unique identifier for each Wix Event
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id (unique for each site)
 * @property {string} event_location - event_location
 * @property {string} rsvp_type - {'yes', 'no', 'maybe' etc)
 * @return {LogObject<submitRsvpSuccessParams>} LogObject<submitRsvpSuccessParams>
 */
export function submitRsvpSuccess(params) {
    return { evid: 1002, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketsCheckoutConfirmation' event (evid: 1003)
 *
 * Event description: tickets_checkout_confirmation
 *
 * @param {ticketsCheckoutConfirmationParams} params - The parameters for this event
 * @property {number} ticket_definition_count - null if no tickets allowed (unique ticket_def_id)
 * @property {GUID} visitorId - visitorId
 * @property {GUID} reservation_id - reservation_id
 * @property {number} total_event_revenue - accumulated order_value (for all orders in this event so far)
 * @property {number} ticket_count - null if no tickets allowed (absolute number of items purchased)
 * @property {string} orderId - order id
 * @property {GUID} uuid - (null is OK as well) uuid being sent when UoU is an actual Wix user
 * @property {GUID} seating_map_guid - id of seating map from which the tickets were purchased; null if no map present,
 * @property {boolean} is_coupon - was the ticket purchased with coupon or not
 * @property {string} event_name - event_name
 * @property {string} paymentmethod - (null for free) paymentmethod
 * @property {number} event_rank - event_rank
 * @property {string} payment_status - (null for free)  a number of cashier payment statuses
 * @property {number} nonfree_ticket_count - same as ticket_count, but for non-free tickets only
 * @property {string} discounted_tickets - a list of ticket ids in the order that  were discounted (separated by comma)
 * @property {string} order_status - (OrderStatus) pending, unpaid, paid, free
 * @property {DateTime} event_start_date - event_start_date
 * @property {boolean} show_image - show_image
 * @property {string} paymentProvider - payment provider
 * @property {number} total_events_count - total_events_count
 * @property {string} currency - (null for free) currency
 * @property {string} revenue_per_ticket - a json that holds ticket id  and revenue for this ticket (price-discount)
 * @property {string} ticket_types - list of ticket ids in the order
 * @property {number} total_order_revenue - total_order_revenue (this order only)
 * @property {GUID} event_id - unique identifier for each Wix Event
 * @property {string} order_origin - {'uou','add_guest_manually','point_of_sale'}
 * @property {GUID} msid - msid
 * @property {boolean} is_manual - FALSE for visitor action, TRUE for wix user action
 * @property {GUID} instance_id - instance_id (unique for each site)
 * @property {GUID} couponId - coupon id for coupon used in order
 * @property {number} appfeeAmount - fee amount in USD
 * @property {string} event_location - event_location
 * @property {GUID} applied_plan_guid - the guid or the pricing plan the discount of which was applied to at least one of the tickets
 * @return {LogObject<ticketsCheckoutConfirmationParams>} LogObject<ticketsCheckoutConfirmationParams>
 */
export function ticketsCheckoutConfirmation(params) {
    return { evid: 1003, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketReservation' event (evid: 1004)
 *
 * Event description: server event to be sent when a reservation is created, to enable us to follow reservation abusers/bots
 *
 * @param {ticketReservationParams} params - The parameters for this event
 * @property {GUID} visitorId - visitorId
 * @property {GUID} reservation_id - reservation_id
 * @property {number} ticket_count - null if no tickets allowed (absolute number of items purchased)
 * @property {GUID} uuid - (null is OK as well) uuid being sent when UoU is an actual Wix user
 * @property {number} event_rank - event_rank
 * @property {boolean} is_logged_in - TRUE for user browsing his own site
 * @property {number} nonfree_ticket_count - same as ticket_count, but for non-free tickets only
 * @property {string} origin - {'web','oa_member_view', 'events_point_of_sale'}
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - unique identifier for each Wix Event
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id (unique for each site)
 * @return {LogObject<ticketReservationParams>} LogObject<ticketReservationParams>
 */
export function ticketReservation(params) {
    return { evid: 1004, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketDownload' event (evid: 1005)
 *
 * Event description: server event to be sent when downloading a ticket in the viewer, to enable us to follow app abusers
 *
 * @param {ticketDownloadParams} params - The parameters for this event
 * @property {string} order_id - order_id
 * @property {GUID} visitorId - visitorId
 * @property {GUID} reservation_id - reservation_id
 * @property {number} ticket_count - null if no tickets allowed (absolute number of items purchased)
 * @property {GUID} uuid - (null is OK as well) uuid being sent when UoU is an actual Wix user
 * @property {number} event_rank - event_rank
 * @property {boolean} is_logged_in - TRUE for user browsing his own site
 * @property {number} nonfree_ticket_count - same as ticket_count, but for non-free tickets only
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - unique identifier for each Wix Event
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id (unique for each site)
 * @return {LogObject<ticketDownloadParams>} LogObject<ticketDownloadParams>
 */
export function ticketDownload(params) {
    return { evid: 1005, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'auditLog' event (evid: 1006)
 *
 * Event description: server event to be sent when a user creates/deletes event, provision, update site setting, temporary event until template bugs will be resolved
 *
 * @param {auditLogParams} params - The parameters for this event
 * @property {string} source - source of the event
 * @property {string} subject - the subject that event is affecting
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} uuid - (null is OK as well) uuid being sent when UoU is an actual Wix user
 * @property {number} event_rank - event_rank
 * @property {boolean} is_logged_in - TRUE for user browsing his own site
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - unique identifier for each Wix Event
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id (unique for each site)
 * @property {string} value - null or data of the action
 * @return {LogObject<auditLogParams>} LogObject<auditLogParams>
 */
export function auditLog(params) {
    return { evid: 1006, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getInvoiceEndpoint' event (evid: 1007)
 *
 * Event description: get invoice endpoint
 *
 * @param {getInvoiceEndpointParams} params - The parameters for this event
 * @property {number} ticket_definition_count - null if no tickets allowed (unique ticket_def_id)
 * @property {GUID} visitorId - visitorId
 * @property {GUID} reservation_id - reservation_id
 * @property {number} total_event_revenue - accumulated order_value (for all orders in this event so far)
 * @property {number} ticket_count - null if no tickets allowed (absolute number of items purchased)
 * @property {string} couponCode - coupon code if exists
 * @property {GUID} uuid - (null is OK as well) uuid being sent when UoU is an actual Wix user
 * @property {boolean} is_coupon - was the ticket purchased with coupon or not
 * @property {string} paymentmethod - (null for free) paymentmethod
 * @property {number} event_rank - event_rank
 * @property {string} payment_status - (null for free)  a number of cashier payment statuses
 * @property {number} nonfree_ticket_count - same as ticket_count, but for non-free tickets only
 * @property {string} order_status - (OrderStatus) pending, unpaid, paid, free
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} currency - (null for free) currency
 * @property {number} total_order_revenue - total_order_revenue (this order only)
 * @property {GUID} event_id - unique identifier for each Wix Event
 * @property {GUID} msid - msid
 * @property {boolean} is_manual - FALSE for visitor action, TRUE for wix user action
 * @property {GUID} instance_id - instance_id (unique for each site)
 * @return {LogObject<getInvoiceEndpointParams>} LogObject<getInvoiceEndpointParams>
 */
export function getInvoiceEndpoint(params) {
    return { evid: 1007, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventPublish' event (evid: 1008)
 *
 * Event description: fired when event is published
 *
 * @param {eventPublishParams} params - The parameters for this event
 * @property {string} splitscreen_event_type - rsvp/ticket
 * @property {boolean} with_image - with_image
 * @property {GUID} visitorId - visitor_id
 * @property {boolean} is_time_tbd - is_time_tbd
 * @property {string} event_name - event_name
 * @property {GUID} event_guid - event_guid
 * @property {number} event_rank - event_rank
 * @property {string} event_timezone - event_timezone
 * @property {DateTime} event_start_date - event_start_date
 * @property {boolean} show_image - show_image
 * @property {string} event_location_type - online/venue
 * @property {number} total_events_count - total_events_count
 * @property {GUID} recurrence_category_id - recurrence_category_id
 * @property {DateTime} event_finish_date - event_finish_date
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_location_tbd - is_location_tbd
 * @return {LogObject<eventPublishParams>} LogObject<eventPublishParams>
 */
export function eventPublish(params) {
    return { evid: 1008, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'saveTicketSuccess' event (evid: 1009)
 *
 * Event description: Firing when ticket definition is created or edited (editing existing or creating a new one)
 *
 * @param {saveTicketSuccessParams} params - The parameters for this event
 * @property {boolean} hide_ticket - true if user selected to hide tickets that are not on sale
 * @property {boolean} is_first_save - TRUE for creating, FALSE for editing
 * @property {string} ticket_fee_type - 'absorb'/'rollon_to_buyer'
 * @property {DateTime} sale_opening_date - user selected opening date for when ticket is sold
 * @property {GUID} visitorId - visitor_id
 * @property {number} price - ticket price (null if free) - floats are not supported, so multiply by 100 before sending
 * @property {string} ticket_policy - ticket policy text given in the relevant field
 * @property {string} ticket_name - ticket_name
 * @property {string} ticket_type - {'free', 'for sale'}
 * @property {string} pricing_options - json value for all pricing options
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} currency - currency
 * @property {DateTime} sale_closing_date - user selected closing date for when ticket is sold
 * @property {number} ticket_quantity - if not limited then NULL
 * @property {GUID} event_id - event_guid
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @property {string} ticket_description - ticket description text given in the relevant field
 * @property {GUID} ticket_definition_id - ticket_definition_id
 * @return {LogObject<saveTicketSuccessParams>} LogObject<saveTicketSuccessParams>
 */
export function saveTicketSuccess(params) {
    return { evid: 1009, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'boLoadingStart' event (evid: 101)
 *
 * Event description: Start of BO loading
 * (previously 68/31 (never actually worked), switched on April 03, 2017)
 * Send it only from Settings Panel
 *
 * @param {boLoadingStartParams} params - The parameters for this event
 * @property {string} comp_id - comp_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<boLoadingStartParams>} LogObject<boLoadingStartParams>
 */
export function boLoadingStart(params) {
    return { evid: 101, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventSettingsSaved' event (evid: 1010)
 *
 * Event description: User clicks save button after making changes to the settings of an event inside the event's page (Overview/Details page, Settings, Features, etc.)
 *
 * @param {eventSettingsSavedParams} params - The parameters for this event
 * @property {string} video_conferencing_type - {'meeting','stream'}, null if not Wix Live
 * @property {number} checkout_time_limit - checkout_time_limit
 * @property {GUID} duplication_source_guid - reference to the event from which this event was created during duplication
 * @property {string} video_conferencing_id - id of video conference if provider is Wix Live
 * @property {GUID} visitorId - visitor_id
 * @property {number} tax_rate - chosen tax rate
 * @property {string} registration_location - {'RSVP','External','Internal'}
 * @property {string} tickets_unavailable_message_text - tickets_unavailable_message_text
 * @property {boolean} is_time_tbd - true if tbd enabled
 * @property {string} event_status - event_status
 * @property {GUID} seating_map_guid - id of seating map connected, null if no seating map is connected. THIS IS INCORRECT, ITS APP ID. NEED FIX!
 * @property {string} tickets_unavailable_button_text - tickets_unavailable_button_text
 * @property {string} registration_status - {'Open',Closed''}
 * @property {string} event_name - event name in details page
 * @property {string} registration_closed_message_text - registration_closed_message_text
 * @property {number} ticket_limit - ticket limit per order
 * @property {string} tax_display - {'add_in_checkout', 'include_in_price'}
 * @property {number} event_rank - event_rank
 * @property {string} registration_url - url given for the external registration
 * @property {string} tax_name - name given in the tax name field
 * @property {string} event_timezone - timezone selected for the event
 * @property {boolean} display_timezone - true of timezone is chosen to be shown
 * @property {string} guest_limit - number of guests set as limit for the event. Null if no limit is provided
 * @property {DateTime} event_start_date - event start date in details page
 * @property {string} guest_info_collection_type - {reg_per_order', 'reg_per_ticket'}
 * @property {boolean} show_image - show_image
 * @property {DateTime} registration_end_date - datetime of selected registration end date if chosen. Null if nothing is selected
 * @property {string} event_location_type - {'online','venue'}
 * @property {number} total_events_count - total_events_count
 * @property {string} registration_channel - {'wix_events', 'different_page', 'no_registration'}
 * @property {string} registration_closed_button_text - registration_closed_button_text
 * @property {string} event_occurrence_type - single/recurring
 * @property {string} registration_form_fields - list of fields included in the registration form. Example: First name, Sample, Email
 * @property {boolean} no_registration_show_event_details - True/False
 * @property {string} type - ticketed, rsvp
 * @property {boolean} video_conference_connected - true if any video conference is enabled
 * @property {GUID} recurrence_category_id - null if event not part of the recurrence batch
 * @property {DateTime} event_finish_date - event finish date in details page
 * @property {GUID} event_id - event guid
 * @property {GUID} msid - msid
 * @property {DateTime} registration_start_date - datetime of selected registration start date if chosen. Null if nothing is selected
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_location_tbd - true if tbd enabled
 * @property {string} limit_reached - option user chooses with guest limit: {'close_registration','add_guests_to_waitlist'}
 * @property {string} main_image - id of the image added to the event
 * @return {LogObject<eventSettingsSavedParams>} LogObject<eventSettingsSavedParams>
 */
export function eventSettingsSaved(params) {
    return { evid: 1010, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventSettingsNotificationsChanged' event (evid: 1011)
 *
 * Event description: User changes one of the settings of their event which are associated with the event-notification service. Is generated on a setting change (click/toggle), shows current setup
 *
 * @param {eventSettingsNotificationsChangedParams} params - The parameters for this event
 * @property {string} reminder_schedule - 1 day/3 days/1 week/30 minutes/1 hour
 * @property {GUID} visitorId - visitor_id
 * @property {boolean} is_pdf_included - true if enabled
 * @property {boolean} confirmation_email - true if enabled
 * @property {boolean} reminder_email - true if enabled
 * @property {boolean} invoice_sending - true if enabled
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {boolean} cancellation_email - true if enabled
 * @property {GUID} event_id - evnet guid
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<eventSettingsNotificationsChangedParams>} LogObject<eventSettingsNotificationsChangedParams>
 */
export function eventSettingsNotificationsChanged(params) {
    return { evid: 1011, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scheduleItemSaved' event (evid: 1012)
 *
 * Event description: User saves schedule item either as part of it's creation or editing an existing one
 *
 * @param {scheduleItemSavedParams} params - The parameters for this event
 * @property {boolean} is_first_save - true if the item is being created
 * @property {boolean} is_description_added - true of description is present
 * @property {GUID} schedule_item_id - schedule item
 * @property {GUID} visitorId - visitor_id
 * @property {string} tags - list of tags given to the item, null if no tags are present
 * @property {boolean} is_place_selected - true if place is selected for the item
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {DateTime} item_end_date - end date given
 * @property {DateTime} item_start_date - start date given
 * @property {GUID} event_id - event id
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<scheduleItemSavedParams>} LogObject<scheduleItemSavedParams>
 */
export function scheduleItemSaved(params) {
    return { evid: 1012, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventPolicySaved' event (evid: 1013)
 *
 * Event description: Event policy is being created or edited
 *
 * @param {eventPolicySavedParams} params - The parameters for this event
 * @property {boolean} is_first_save - true if the policy is being created
 * @property {boolean} is_description_added - true if description is present
 * @property {GUID} policy_id - policy id
 * @property {GUID} visitorId - visitor_id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} policy_name - name given to policy
 * @property {GUID} event_id - event id
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<eventPolicySavedParams>} LogObject<eventPolicySavedParams>
 */
export function eventPolicySaved(params) {
    return { evid: 1013, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulePublished' event (evid: 1014)
 *
 * Event description: User clicked saved on schedule item list, publishing the items
 *
 * @param {schedulePublishedParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor_id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {number} schedule_item_count - number of items present in the schedule upon save/publish
 * @property {GUID} event_id - event id
 * @property {string} scheduleList - array of schedule item ids published
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<schedulePublishedParams>} LogObject<schedulePublishedParams>
 */
export function schedulePublished(params) {
    return { evid: 1014, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'notificationsAudit' event (evid: 1015)
 *
 * Event description: Event containing audit information about events notifications. Used for debugging issues.
 *
 * @param {notificationsAuditParams} params - The parameters for this event
 * @property {string} subject - subject
 * @property {GUID} visitorId - visitor id
 * @property {GUID} rsvpId - rsvp id
 * @property {GUID} uuid - (null is OK as well) uuid being sent when UoU is an actual Wix user
 * @property {boolean} areNewSpotsOpened - are new spots opened
 * @property {string} orderStatus - order status
 * @property {number} event_rank - event_rank
 * @property {string} notificationType - notification type
 * @property {string} rsvpStatus - rsvp status
 * @property {string} error - error
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} details - details
 * @property {string} guestIds - array of uuids
 * @property {string} ticketNumbers - array of ticket numbers
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @property {string} ordernumber - order number
 * @property {boolean} isSilent - is silent
 * @property {GUID} taskId - task id
 * @property {GUID} eventid - unique identifier for each Wix Event
 * @return {LogObject<notificationsAuditParams>} LogObject<notificationsAuditParams>
 */
export function notificationsAudit(params) {
    return { evid: 1015, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketSalesStatusUpdateScheduled' event (evid: 1016)
 *
 * Event description: Firing when ticket with sales period definition is created or edited
 *
 * @param {ticketSalesStatusUpdateScheduledParams} params - The parameters for this event
 * @property {DateTime} execution_time - execution_time
 * @property {DateTime} sale_opening_date - user selected opening date for when ticket is sold
 * @property {GUID} visitorId - visitor_id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {DateTime} sale_closing_date - user selected closing date for when ticket is sold
 * @property {number} ticket_quantity - if not limited then NULL
 * @property {GUID} event_id - event_guid
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @property {string} update_type - update_type
 * @property {GUID} ticket_definition_id - ticket_definition_id
 * @return {LogObject<ticketSalesStatusUpdateScheduledParams>} LogObject<ticketSalesStatusUpdateScheduledParams>
 */
export function ticketSalesStatusUpdateScheduled(params) {
    return { evid: 1016, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketSalesStatusUpdated' event (evid: 1017)
 *
 * Event description: Firing when ticket sales status gets updated
 *
 * @param {ticketSalesStatusUpdatedParams} params - The parameters for this event
 * @property {string} sale_status - {'SALE_SCHEDULED','SALE_ENDED', 'SALE_STARTED','NA'}
 * @property {DateTime} execution_time - execution_time
 * @property {DateTime} sale_opening_date - user selected opening date for when ticket is sold
 * @property {GUID} visitorId - visitor_id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {DateTime} sale_closing_date - user selected closing date for when ticket is sold
 * @property {number} ticket_quantity - if not limited then NULL
 * @property {GUID} event_id - event_guid
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @property {GUID} ticket_definition_id - ticket_definition_id
 * @return {LogObject<ticketSalesStatusUpdatedParams>} LogObject<ticketSalesStatusUpdatedParams>
 */
export function ticketSalesStatusUpdated(params) {
    return { evid: 1017, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketSalesStatusUpdateCanceled' event (evid: 1018)
 *
 * Event description: For temporary monitoring related to tickets with sales period
 *
 * @param {ticketSalesStatusUpdateCanceledParams} params - The parameters for this event
 * @property {DateTime} execution_time - execution_time
 * @property {GUID} visitorId - visitor_id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event_guid
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @property {string} update_type - update_type
 * @property {GUID} ticket_definition_id - ticket_definition_id
 * @return {LogObject<ticketSalesStatusUpdateCanceledParams>} LogObject<ticketSalesStatusUpdateCanceledParams>
 */
export function ticketSalesStatusUpdateCanceled(params) {
    return { evid: 1018, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'staffMemberEdited' event (evid: 1019)
 *
 * Event description: Event fired when staff member is saved, deleted, paused access, given access
 *
 * @param {staffMemberEditedParams} params - The parameters for this event
 * @property {string} event_access - {all_events, specific_events}
 * @property {string} staff_member_name - staff_member_name
 * @property {GUID} visitorId - visitor_id
 * @property {string} scope - {CHECK_IN_GUESTS, SELL_TICKETS, UNKNOWN_SCOPE}
 * @property {GUID} staff_member_id - staff_member_id
 * @property {GUID} event_guid - event_guid
 * @property {number} event_rank - event_rank
 * @property {string} staff_member_status - {PENDING, HAS_ACCESS, ACCESS_PAUSED}
 * @property {number} eventsCount - numbers of events that member has access to
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<staffMemberEditedParams>} LogObject<staffMemberEditedParams>
 */
export function staffMemberEdited(params) {
    return { evid: 1019, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'boLoadingFinish' event (evid: 102)
 *
 * Event description: Finish of loading the BO by event owner.
 * (previously 68/32, switched on April 03, 2017)
 *
 * @param {boLoadingFinishParams} params - The parameters for this event
 * @property {string} tab_name - the tab it's loading
 * @property {string} comp_id - comp_id
 * @property {GUID} instance_id - instance_id
 * @property {number} loading_time - loading time in ms
 * @return {LogObject<boLoadingFinishParams>} LogObject<boLoadingFinishParams>
 */
export function boLoadingFinish(params) {
    return { evid: 102, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventSaveClick' event (evid: 103)
 *
 * Event description: Create your event / Save your event click
 * (previously 68/17, switched on April 03, 2017). Should be also sent when clicking 'Save and Exit' in unsaved changes popup. Should be also sent when clicked Publish on draft event.
 *
 * @param {eventSaveClickParams} params - The parameters for this event
 * @property {string} splitscreen_event_type - {'rsvp', 'ticketed'}
 * @property {boolean} draft_event - draft_event
 * @property {boolean} is_time_tbd - true if the event was saved with "Time is TBD" toggled on
 * @property {string} added_categories - list of added categories ids
 * @property {string} event_name - event_name
 * @property {boolean} has_tickets - t/f
 * @property {string} event_timezone - event_timezone
 * @property {string} create_event_button - {'top', 'bottom'} - available only for new event. in case of editing the existing event, will send 'save' for all buttons
 * @property {DateTime} event_start_date - event_start_date
 * @property {string} comp_id - comp_id
 * @property {string} removed_categories - list of removed categories ids
 * @property {DateTime} event_finish_date - event_finish_date
 * @property {boolean} is_adi_intro - states whether the event was created in the intro phase or after creating the site
 * @property {GUID} event_id - send blank if not available (the first save)
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_location_tbd - true if the event was saved with "Location is TBD" toggled on
 * @property {boolean} is_first_event_save - bool: True for creating, False for saving (after first create)
 * @property {GUID} groupid - group id, present if Group is connected
 * @property {string} event_location - should be blank (pii)
 * @return {LogObject<eventSaveClickParams>} LogObject<eventSaveClickParams>
 */
export function eventSaveClick(params) {
    return { evid: 103, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventSaveSuccess' event (evid: 104)
 *
 * Event description: Create your event / Save your event - success
 * (previously 68/28 (never actually worked), switched on April 03, 2017)
 * Should include total_events_count param (appears in Implicit fields). Should be also sent when clicking 'Save and Exit' in unsaved changes popup.
 *
 * @param {eventSaveSuccessParams} params - The parameters for this event
 * @property {string} splitscreen_event_type - {'ticketed', 'rsvp'}
 * @property {GUID} duplication_source_guid - event_guid of the event from which the current event was created. Also includes events created from templates (need to filter for is_first_event_save=true or draft_status=true to distinguish between the two). Null if the event wasn't created from duplication.
 * @property {boolean} with_image - TRUE when the event is saved with an image
 * @property {boolean} draft_event - draft_event
 * @property {boolean} show_event_end_date - show_event_end_date
 * @property {boolean} is_time_tbd - true if the event was saved with "Time is TBD" toggled on
 * @property {string} added_categories - list of added categories ids
 * @property {boolean} with_about - User has typed something in "About" field
 * @property {boolean} include_link_in_reminder - t/f
 * @property {string} event_name - event_name
 * @property {string} video_conferencing_provider - {'wix_live', 'zoom'} null if no integration
 * @property {boolean} with_teaser - User has typed something in "Short teaser" field
 * @property {string} video_conference_type - {'meeting', 'stream'} null if not wix video
 * @property {number} occurrences_count - count of occurrences
 * @property {string} event_timezone - event_timezone
 * @property {boolean} display_timezone - true if the event is saved with 'display timezone' enabled
 * @property {DateTime} event_start_date - event_start_date
 * @property {boolean} include_link_in_confirmation - t/f
 * @property {string} event_location_type - online/physical
 * @property {string} comp_id - comp_id
 * @property {string} removed_categories - list of removed categories ids
 * @property {string} event_occurrence_type - single/recurring
 * @property {boolean} video_conference_connected - t/f/null if no account connected
 * @property {GUID} recurrence_category_id - recurrence_category_id
 * @property {DateTime} event_finish_date - event_finish_date
 * @property {boolean} is_adi_intro - states whether the event was created in the intro phase or after creating the site
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_location_tbd - true if the event was saved with "Location is TBD" toggled on
 * @property {string} action - save/publish
 * @property {boolean} is_first_event_save - is_first_event_save
 * @property {GUID} groupid - group id, present if Group is connected
 * @property {string} event_location - event_location
 * @property {boolean} is_ai_generated - describes if the event is generated by AI or created by the user
 * @return {LogObject<eventSaveSuccessParams>} LogObject<eventSaveSuccessParams>
 */
export function eventSaveSuccess(params) {
    return { evid: 104, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addEventClick' event (evid: 106)
 *
 * Event description: Clicking on the 'add event' or 'create event' button in the BO My Events, BO cancelled event page, BO over event page or in settings panel
 *
 * @param {addEventClickParams} params - The parameters for this event
 * @property {boolean} draft_event - draft_event
 * @property {string} tab_name - {'settings_main', 'my events', ‘cancelled event’, ‘over event’}
 * @property {string} button_name - {'add event','add', 'create new event'} in OneApp {mobile BO, first client toast}
 * @property {string} comp_id - comp_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<addEventClickParams>} LogObject<addEventClickParams>
 */
export function addEventClick(params) {
    return { evid: 106, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editEventClick' event (evid: 108)
 *
 * Event description: Click on one of the event edit options:
 * edit, view guests, cancel, duplicate, send an invite etc:
 * My events tab in BO
 * Cancel in Event Details
 * Cancelled event page
 * My Events tab in Settings Panel
 *
 * @param {editEventClickParams} params - The parameters for this event
 * @property {boolean} draft_event - draft_event
 * @property {string} button_name - shows where the action lands the user { 'edit', 'view guests', 'cancel', 'duplicate', 'duplicate and reuse', 'reuse''send an invite' etc}
 * @property {string} page_name - {'settings panel', 'bo my events', 'event details', 'cancelled event','event_switch_view'}
 * @property {string} origin - {'suggested_action','edit_button','event_card','more_actions','check-in'}
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<editEventClickParams>} LogObject<editEventClickParams>
 */
export function editEventClick(params) {
    return { evid: 108, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventCancelPopupClick' event (evid: 109)
 *
 * Event description: Click on 'cancel', 'dont cancel' or 'X' button in event cancellation popup.
 * Was partially implemented as 68/30 in the past (but isn't firing in ALL occasions and has too many params.)
 *
 * @param {eventCancelPopupClickParams} params - The parameters for this event
 * @property {string} button_name - {'cancel', 'dismiss', 'dont'}
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<eventCancelPopupClickParams>} LogObject<eventCancelPopupClickParams>
 */
export function eventCancelPopupClick(params) {
    return { evid: 109, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'myEventsOpened' event (evid: 111)
 *
 * Event description: Loading 'My Events' section by clicking on 'My events' tab in BO or arriving from settings/gfpp/save event action.
 * Should include total_events_count param (appears in Implicit fields).
 * By default is opened in Upcoming tab (unless it has zero events). Same in case draft events tab opened.
 *
 * @param {myEventsOpenedParams} params - The parameters for this event
 * @property {string} section_type - {'Published Events','Drafts','OA Published Single','OA Published Recurring','OA Drafts'}
 * @property {string} comp_id - comp_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<myEventsOpenedParams>} LogObject<myEventsOpenedParams>
 */
export function myEventsOpened(params) {
    return { evid: 111, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventTabOpened' event (evid: 113)
 *
 * Event description: Load of each one of the single event tabs:
 * event_details, general_options, registration_form, invitation, guest_list.
 * When arriving from outside (not from an other tab), last_tab_name could be BLANK. event_switch_view is used to show usage of the feature (from event name click)
 *
 * @param {eventTabOpenedParams} params - The parameters for this event
 * @property {boolean} draft_event - draft_event
 * @property {string} tab_name - {'event_details', 'general_options', 'registration_form', 'invitation', 'guest_list','event_switch_view'}
 * @property {string} last_tab_name - {null, 'event_details', 'general_options', 'registration_form', 'invitation', 'guest_list','event_switch_view'}
 * @property {boolean} isEmptyState - true for empty state
 * @property {string} type_of_event - {'rsvp', 'ticketed'}
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<eventTabOpenedParams>} LogObject<eventTabOpenedParams>
 */
export function eventTabOpened(params) {
    return { evid: 113, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'emailAlertsChanged' event (evid: 116)
 *
 * Event description: General Options tab:
 * email_alerts_changed
 *
 * @param {emailAlertsChangedParams} params - The parameters for this event
 * @property {string} status - {'daily','rsvp',null}
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<emailAlertsChangedParams>} LogObject<emailAlertsChangedParams>
 */
export function emailAlertsChanged(params) {
    return { evid: 116, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'automaticEmailsChanged' event (evid: 117)
 *
 * Event description: General Options tab:
 * automatic_emails_changed
 *
 * @param {automaticEmailsChangedParams} params - The parameters for this event
 * @property {boolean} waiting_list_email - waiting_list_email
 * @property {string} reminder_schedule - 1 day/3 days/1 week/30 minutes/1 hour
 * @property {boolean} is_pdf_included - TRUE if ticket PDF is included, FALSE if not included, NULL if there is no checkbox in the form
 * @property {boolean} confirmation_email - confirmation_email
 * @property {boolean} reminder_email - reminder_email
 * @property {boolean} include_video_conference_link - true/false
 * @property {string} comp_id - comp_id
 * @property {boolean} cancellation_email - cancellation_email
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<automaticEmailsChangedParams>} LogObject<automaticEmailsChangedParams>
 */
export function automaticEmailsChanged(params) {
    return { evid: 117, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareEventClick' event (evid: 120)
 *
 * Event description: Invitations tab:
 * Social networks Share click
 * (previously - 68/22)
 *
 * @param {shareEventClickParams} params - The parameters for this event
 * @property {string} button_name - {'facebook','twitter','linkedin'}
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<shareEventClickParams>} LogObject<shareEventClickParams>
 */
export function shareEventClick(params) {
    return { evid: 120, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'notificationsAuditSrc68Evid1201' event (evid: 1201)
 *
 * Event description: Event containing audit information about events notifications. Used for debugging issues.
 *
 * @param {notificationsAuditSrc68Evid1201Params} params - The parameters for this event
 * @property {string} subject - subject
 * @property {GUID} visitorId - (null is OK as well) uuid being sent when UoU is an actual Wix user
 * @property {GUID} rsvpId - rsvp id
 * @property {boolean} areNewSpotsOpened - are new spots opened
 * @property {string} orderStatus - order status
 * @property {string} notificationType - notification type
 * @property {string} rsvpStatus - rsvp status
 * @property {string} error - error
 * @property {string} details - details
 * @property {string} guestIds - array of uuids
 * @property {string} ticketNumbers - array of ticket numbers
 * @property {GUID} msid - msid
 * @property {string} ordernumber - order number
 * @property {boolean} isSilent - is silent
 * @property {GUID} taskId - task id
 * @property {GUID} eventid - event_guid
 * @property {string} message - message
 * @property {string} message_subject - message_subject
 * @property {string} message_details - message_details
 * @return {LogObject<notificationsAuditSrc68Evid1201Params>} LogObject<notificationsAuditSrc68Evid1201Params>
 */
export function notificationsAuditSrc68Evid1201(params) {
    return { evid: 1201, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'staffMemberEditedSrc68Evid1202' event (evid: 1202)
 *
 * Event description: Event fired when staff member is saved, deleted, paused access, given access
 *
 * @param {staffMemberEditedSrc68Evid1202Params} params - The parameters for this event
 * @property {string} event_access - {all_events, specific_events}
 * @property {string} staff_member_name - staff_member_name
 * @property {string} scope - {CHECK_IN_GUESTS, SELL_TICKETS, UNKNOWN_SCOPE}
 * @property {GUID} staff_member_id - staff_member_id
 * @property {string} staff_member_status - {PENDING, HAS_ACCESS, ACCESS_PAUSED}
 * @property {number} eventsCount - numbers of events that member has access to
 * @property {GUID} msid - msid
 * @return {LogObject<staffMemberEditedSrc68Evid1202Params>} LogObject<staffMemberEditedSrc68Evid1202Params>
 */
export function staffMemberEditedSrc68Evid1202(params) {
    return { evid: 1202, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sendInvitationClick' event (evid: 121)
 *
 * Event description: Invitations tab:
 * send_invitation
 * (previously - 68/22)
 *
 * @param {sendInvitationClickParams} params - The parameters for this event
 * @property {GUID} so_template_id - ShoutOut template ID
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<sendInvitationClickParams>} LogObject<sendInvitationClickParams>
 */
export function sendInvitationClick(params) {
    return { evid: 121, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'mySoClick' event (evid: 122)
 *
 * Event description: Invitations tab:
 * my_so_click
 * (previously - 68/22)
 *
 * @param {mySoClickParams} params - The parameters for this event
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<mySoClickParams>} LogObject<mySoClickParams>
 */
export function mySoClick(params) {
    return { evid: 122, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modalTriggerLiveSiteSrc68Evid1232' event (evid: 1232)
 *
 * Event description: Event fires when modal opens in live site.
 *
 * @param {modalTriggerLiveSiteSrc68Evid1232Params} params - The parameters for this event
 * @property {string} modal_name - the name of the modal
 * @property {string} origin - location of the modal
 * @property {GUID} event_id - event_id
 * @return {LogObject<modalTriggerLiveSiteSrc68Evid1232Params>} LogObject<modalTriggerLiveSiteSrc68Evid1232Params>
 */
export function modalTriggerLiveSiteSrc68Evid1232(params) {
    return { evid: 1232, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeRsvpClick' event (evid: 125)
 *
 * Event description: For RSVP event in Guest List tab - user changes the rsvp status of guests and confirms the change in the pop-up (if applicable)
 *
 * @param {changeRsvpClickParams} params - The parameters for this event
 * @property {number} waiting_list_guest_count - current state of chosen users
 * @property {number} confirmed_guests_count - current state of chosen users
 * @property {string} origin - {'guest_list','rsvp_details_list','edit_guest_info','rsvps_in_tickets'}
 * @property {number} declined_guests_count - current state of chosen users
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @property {string} rsvp_type - suggested change: {'going', 'not going', 'waitlist'}
 * @return {LogObject<changeRsvpClickParams>} LogObject<changeRsvpClickParams>
 */
export function changeRsvpClick(params) {
    return { evid: 125, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteGuestClick' event (evid: 127)
 *
 * Event description: For RSVP event in Guest List tab - user deletes the guest and confirms in the pop-up (if applicable)
 *
 * @param {deleteGuestClickParams} params - The parameters for this event
 * @property {number} waiting_list_guest_count - chosen users - before the deletion
 * @property {number} confirmed_guests_count - chosen users - before the deletion
 * @property {string} origin - {'guest_list','rsvp_details_list','edit_guest_info','rsvps_in_tickets'}
 * @property {number} declined_guests_count - chosen users - before the deletion
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<deleteGuestClickParams>} LogObject<deleteGuestClickParams>
 */
export function deleteGuestClick(params) {
    return { evid: 127, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editGuestClick' event (evid: 129)
 *
 * Event description: Guest List tab:
 * edit_guest_click
 *
 * @param {editGuestClickParams} params - The parameters for this event
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<editGuestClickParams>} LogObject<editGuestClickParams>
 */
export function editGuestClick(params) {
    return { evid: 129, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsTabClicked' event (evid: 13)
 *
 * Event description: Settings Panel tab clicked by Site owner. Currently available tabs:
 * {'main', 'layout', 'settings', 'design'}
 *
 * @param {settingsTabClickedParams} params - The parameters for this event
 * @property {number} total_guests_count - total_guests_count
 * @property {string} editor_view_mode - {'mobile', 'desktop'}
 * @property {number} waiting_list_guest_count - waiting_list_guest_count
 * @property {string} tab_name - {'main', 'layout', 'settings', 'design'}
 * @property {string} last_tab_name - {'main', 'layout', 'settings', 'design'}
 * @property {number} confirmed_guests_count - vconfirmed_guests_count
 * @property {boolean} is_demo_data - bool
 * @property {number} event_capacity - event_capacity
 * @property {number} questions_count - questions_count
 * @property {string} event_name - event_name
 * @property {string} event_timezone - event_timezone
 * @property {DateTime} event_start_date - event_start_date
 * @property {string} origin - {'main_page', 'details_page', 'registration_page'}
 * @property {number} declined_guests_count - declined_guests_count
 * @property {string} comp_id - comp_id
 * @property {boolean} is_first_event - bool - hardcoded TRUE until we implement multiple events feature
 * @property {DateTime} event_finish_date - event_finish_date
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @property {string} event_location - event_location
 * @return {LogObject<settingsTabClickedParams>} LogObject<settingsTabClickedParams>
 */
export function settingsTabClicked(params) {
    return { evid: 13, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'widgetChangeLayout' event (evid: 133)
 *
 * Event description: On Widget level
 *
 * @param {widgetChangeLayoutParams} params - The parameters for this event
 * @property {string} display_type - {'single', 'multiple''}
 * @property {string} layout_type - {tbd}
 * @property {string} comp_id - comp_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<widgetChangeLayoutParams>} LogObject<widgetChangeLayoutParams>
 */
export function widgetChangeLayout(params) {
    return { evid: 133, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sellTicketsGetStartedClick' event (evid: 135)
 *
 * Event description: clicking on get started in Tickets tab (first time experience)
 *
 * @param {sellTicketsGetStartedClickParams} params - The parameters for this event
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<sellTicketsGetStartedClickParams>} LogObject<sellTicketsGetStartedClickParams>
 */
export function sellTicketsGetStartedClick(params) {
    return { evid: 135, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'saveTicketClick' event (evid: 136)
 *
 * Event description: Clicking on saving Ticket (editing existing or creating a new one)
 *
 * @param {saveTicketClickParams} params - The parameters for this event
 * @property {boolean} hide_ticket - true if user selected to hide tickets that are not on sale
 * @property {boolean} is_first_save - TRUE for creating, FALSE for editing
 * @property {string} ticket_fee_type - 'absorb'/'rollon_to_buyer'
 * @property {DateTime} sale_opening_date - user selected opening date for when ticket is sold
 * @property {number} price - ticket price (null if free) - floats are not supported, so multiply by 100 before sending
 * @property {string} ticket_name - ticket_name
 * @property {string} ticket_type - {'free', 'for sale'}
 * @property {string} pricing_options - json value for all pricing options
 * @property {string} currency - currency_id (3 characters)
 * @property {DateTime} sale_closing_date - user selected closing date for when ticket is sold
 * @property {string} comp_id - comp_id
 * @property {number} ticket_quantity - if not limited then NULL
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @property {GUID} ticket_definition_id - null when creating a new one, unique identifier of each ticket (name, not a single UoU ticket)
 * @property {boolean} is_ai_created - true if ticket created with AI, false if created manually
 * @return {LogObject<saveTicketClickParams>} LogObject<saveTicketClickParams>
 */
export function saveTicketClick(params) {
    return { evid: 136, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeCurrencySubmitClick' event (evid: 139)
 *
 * Event description: click on submitting currency change
 *
 * @param {changeCurrencySubmitClickParams} params - The parameters for this event
 * @property {number} ticket_definition_count - number of ticket_definition_id
 * @property {string} currency - new currency
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<changeCurrencySubmitClickParams>} LogObject<changeCurrencySubmitClickParams>
 */
export function changeCurrencySubmitClick(params) {
    return { evid: 139, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createNewTicketClick' event (evid: 140)
 *
 * Event description: click on creating new ticket
 *
 * @param {createNewTicketClickParams} params - The parameters for this event
 * @property {string} button_name - there are two diff buttons there
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<createNewTicketClickParams>} LogObject<createNewTicketClickParams>
 */
export function createNewTicketClick(params) {
    return { evid: 140, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dummyName' event (evid: 1400)
 *
 * Event description: dummy-name.
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params) {
    return { evid: 1400, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'staffMemberEditedSrc68Evid1401' event (evid: 1401)
 *
 * Event description: Event fired when staff member is saved, deleted, paused access, given access
 *
 * @param {staffMemberEditedSrc68Evid1401Params} params - The parameters for this event
 * @property {string} event_access - event_access
 * @property {string} staff_member_name - staff_member_name
 * @property {string} scope - {CHECK_IN_GUESTS, SELL_TICKETS, UNKNOWN_SCOPE}
 * @property {GUID} staff_member_id - staff_member_id
 * @property {GUID} meta_site_id - meta_site_id
 * @property {GUID} event_guid - event_guid
 * @property {string} staff_member_status - {PENDING, HAS_ACCESS, ACCESS_PAUSED}
 * @property {number} events_count - events_count
 * @property {string} action - {edit, create, delete}
 * @return {LogObject<staffMemberEditedSrc68Evid1401Params>} LogObject<staffMemberEditedSrc68Evid1401Params>
 */
export function staffMemberEditedSrc68Evid1401(params) {
    return { evid: 1401, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editTicketClickSrc68Evid141' event (evid: 141)
 *
 * Event description: edit_ticket_click (clicking on ticket actions)
 *
 * @param {editTicketClickSrc68Evid141Params} params - The parameters for this event
 * @property {string} button_name - {box, edit, duplicate, delete, view}
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @property {GUID} ticket_definition_id - ticket_definition_id
 * @return {LogObject<editTicketClickSrc68Evid141Params>} LogObject<editTicketClickSrc68Evid141Params>
 */
export function editTicketClickSrc68Evid141(params) {
    return { evid: 141, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketHideClick' event (evid: 142)
 *
 * Event description: click on hiding/unhiding the ticket to visitors
 *
 * @param {ticketHideClickParams} params - The parameters for this event
 * @property {string} button_name - {hide, show} - the new state of the ticker
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @property {GUID} ticket_definition_id - ticket_definition_id
 * @return {LogObject<ticketHideClickParams>} LogObject<ticketHideClickParams>
 */
export function ticketHideClick(params) {
    return { evid: 142, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createInvitationFromGuestListClick' event (evid: 143)
 *
 * Event description: clicking on create an invitation from guest list (first time experience)
 *
 * @param {createInvitationFromGuestListClickParams} params - The parameters for this event
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<createInvitationFromGuestListClickParams>} LogObject<createInvitationFromGuestListClickParams>
 */
export function createInvitationFromGuestListClick(params) {
    return { evid: 143, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'orderDetailsClick' event (evid: 144)
 *
 * Event description: clicking on opening an order details page
 *
 * @param {orderDetailsClickParams} params - The parameters for this event
 * @property {string} order_id - order_id
 * @property {string} guest_status - {paid, unpaid, free}
 * @property {string} tabName - 'orders'/'guest_list'
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<orderDetailsClickParams>} LogObject<orderDetailsClickParams>
 */
export function orderDetailsClick(params) {
    return { evid: 144, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'removeOrdersFromTheListClick' event (evid: 145)
 *
 * Event description: click on remove orders from the list button
 *
 * @param {removeOrdersFromTheListClickParams} params - The parameters for this event
 * @property {string} tabName - 'orders'/'guest_list'
 * @property {number} orders_count - orders_count
 * @property {string} origin - order details or orders list
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<removeOrdersFromTheListClickParams>} LogObject<removeOrdersFromTheListClickParams>
 */
export function removeOrdersFromTheListClick(params) {
    return { evid: 145, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'removeOrdersFromTheListConfirm' event (evid: 146)
 *
 * Event description: confirm removing orders from the list button
 *
 * @param {removeOrdersFromTheListConfirmParams} params - The parameters for this event
 * @property {number} orders_count - orders_count
 * @property {string} origin - order details or orders list
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<removeOrdersFromTheListConfirmParams>} LogObject<removeOrdersFromTheListConfirmParams>
 */
export function removeOrdersFromTheListConfirm(params) {
    return { evid: 146, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'markOrdersAsPaidClick' event (evid: 147)
 *
 * Event description: click on marking orders as paid
 *
 * @param {markOrdersAsPaidClickParams} params - The parameters for this event
 * @property {number} orders_count - orders_count
 * @property {string} origin - order details or orders list
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<markOrdersAsPaidClickParams>} LogObject<markOrdersAsPaidClickParams>
 */
export function markOrdersAsPaidClick(params) {
    return { evid: 147, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'markOrdersAsPaidConfirm' event (evid: 148)
 *
 * Event description: click on confirming marking orders as paid
 *
 * @param {markOrdersAsPaidConfirmParams} params - The parameters for this event
 * @property {number} orders_count - orders_count
 * @property {string} origin - order details or orders list
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<markOrdersAsPaidConfirmParams>} LogObject<markOrdersAsPaidConfirmParams>
 */
export function markOrdersAsPaidConfirm(params) {
    return { evid: 148, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editOrderClick' event (evid: 149)
 *
 * Event description: click on editing order (resend ticket, download ticket, remove guest)
 *
 * @param {editOrderClickParams} params - The parameters for this event
 * @property {string} order_id - order_id
 * @property {string} guest_status - {paid, unpaid, free}
 * @property {string} button_name - resend, download, remove, show-invoice, create-invoice, etc
 * @property {string} tabName - 'orders'/'guest_list'
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<editOrderClickParams>} LogObject<editOrderClickParams>
 */
export function editOrderClick(params) {
    return { evid: 149, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createManageEventClick' event (evid: 15)
 *
 * Event description: Create or Manage event click by Site owner in Settings panel
 *
 * @param {createManageEventClickParams} params - The parameters for this event
 * @property {number} total_guests_count - total_guests_count
 * @property {number} waiting_list_guest_count - waiting_list_guest_count
 * @property {string} tab_name - {'main', 'layout', 'settings', 'design'}
 * @property {number} confirmed_guests_count - confirmed_guests_count
 * @property {boolean} is_demo_data - bool
 * @property {number} event_capacity - event_capacity
 * @property {number} questions_count - questions_count
 * @property {string} button_name - {'create_event', 'manage_event'}
 * @property {string} event_name - event_name
 * @property {string} event_timezone - event_timezone
 * @property {DateTime} event_start_date - event_start_date
 * @property {number} declined_guests_count - declined_guests_count
 * @property {string} comp_id - comp_id
 * @property {boolean} is_first_event - bool - hardcoded TRUE until we implement multiple events feature
 * @property {DateTime} event_finish_date - event_finish_date
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @property {string} event_location - event_location
 * @return {LogObject<createManageEventClickParams>} LogObject<createManageEventClickParams>
 */
export function createManageEventClick(params) {
    return { evid: 15, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteTicket' event (evid: 152)
 *
 * Event description: Clicking on (confirming) deleting Ticket (in popup)
 *
 * @param {deleteTicketParams} params - The parameters for this event
 * @property {string} ticket_type - {'free', 'for sale'}
 * @property {string} currency - currency_id (3 characters)
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @property {GUID} ticket_definition_id - null when creating a new one, unique identifier of each ticket (name, not a single UoU ticket)
 * @return {LogObject<deleteTicketParams>} LogObject<deleteTicketParams>
 */
export function deleteTicket(params) {
    return { evid: 152, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'resendTicket' event (evid: 153)
 *
 * Event description: Clicking on (confirming) resending Ticket (order) in popup
 *
 * @param {resendTicketParams} params - The parameters for this event
 * @property {string} order_id - order_id
 * @property {string} currency - currency_id (3 characters)
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<resendTicketParams>} LogObject<resendTicketParams>
 */
export function resendTicket(params) {
    return { evid: 153, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oneAppBannerClicked' event (evid: 154)
 *
 * Event description: user clicked on the one app promotion
 *
 * @param {oneAppBannerClickedParams} params - The parameters for this event
 * @property {string} origin - banner's location
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oneAppBannerClickedParams>} LogObject<oneAppBannerClickedParams>
 */
export function oneAppBannerClicked(params) {
    return { evid: 154, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'maActionClicked' event (evid: 156)
 *
 * Event description: uou clicked on action in members area
 *
 * @param {maActionClickedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} tabName - past_events/upcoming_events
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} action - see_other_events/expand_event_details/view_event_details/share_event/switch_between_tabs
 * @return {LogObject<maActionClickedParams>} LogObject<maActionClickedParams>
 */
export function maActionClicked(params) {
    return { evid: 156, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refundOrderDone' event (evid: 157)
 *
 * Event description: when user refunds an order from orders tab
 *
 * @param {refundOrderDoneParams} params - The parameters for this event
 * @property {GUID} orderId - []
 * @property {number} price - price of refund
 * @property {string} currency - currency of refund
 * @property {GUID} event_id - []
 * @property {GUID} instance_id - []
 * @return {LogObject<refundOrderDoneParams>} LogObject<refundOrderDoneParams>
 */
export function refundOrderDone(params) {
    return { evid: 157, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'coronaBannerClick' event (evid: 158)
 *
 * Event description: user clicked corona banner
 *
 * @param {coronaBannerClickParams} params - The parameters for this event
 * @property {GUID} instance_id - []
 * @return {LogObject<coronaBannerClickParams>} LogObject<coronaBannerClickParams>
 */
export function coronaBannerClick(params) {
    return { evid: 158, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'zoomConferenceSetup' event (evid: 159)
 *
 * Event description: setup video conferencing for an event
 *
 * @param {zoomConferenceSetupParams} params - The parameters for this event
 * @property {string} video_conferencing_provider - {'wix_live', 'zoom'} null for setup action
 * @property {GUID} event_id - []
 * @property {GUID} instance_id - []
 * @property {string} action - setup/connect/done
 * @return {LogObject<zoomConferenceSetupParams>} LogObject<zoomConferenceSetupParams>
 */
export function zoomConferenceSetup(params) {
    return { evid: 159, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'startZoomMeeting' event (evid: 160)
 *
 * Event description: Click the available zoom button on the event card. Currently - View Zoom links (Start zoom meeting click in BO event list)
 *
 * @param {startZoomMeetingParams} params - The parameters for this event
 * @property {GUID} event_id - []
 * @property {GUID} instance_id - []
 * @return {LogObject<startZoomMeetingParams>} LogObject<startZoomMeetingParams>
 */
export function startZoomMeeting(params) {
    return { evid: 160, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'trash' event (evid: 1600)
 *
 * Event description: trash.
 *
 * @param {trashParams} params - The parameters for this event
 * @return {LogObject<trashParams>} LogObject<trashParams>
 */
export function trash(params) {
    return { evid: 1600, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'submitRsvpSuccessSrc68Evid1601' event (evid: 1601)
 *
 * Event description: success event of submit rsvp click by site guest
 *
 * @param {submitRsvpSuccessSrc68Evid1601Params} params - The parameters for this event
 * @property {number} total_guests_count - total_guests_count
 * @property {GUID} visitorId - visitor_id
 * @property {number} waiting_list_guest_count - waiting_list_guest_count
 * @property {GUID} uuid - uuid being sent when UoU is an actual Wix user
 * @property {number} confirmed_guests_count - confirmed_guests_count
 * @property {boolean} is_demo_data - is_demo_data
 * @property {boolean} is_deleted - is_deleted
 * @property {number} event_capacity - event_capacity
 * @property {number} questions_count - questions_count
 * @property {string} event_name - event_name
 * @property {GUID} meta_site_id - meta_site_id
 * @property {GUID} rsvp_id - rsvp_id
 * @property {DateTime} event_start_date - event_start_date
 * @property {number} visitor_rsvp_count - visitor_rsvp_count
 * @property {number} declined_guests_count - declined_guests_count
 * @property {GUID} event_id - event_id
 * @property {string} event_location - event_location
 * @property {string} rsvp_type - {'yes', 'no', 'maybe' etc)
 * @return {LogObject<submitRsvpSuccessSrc68Evid1601Params>} LogObject<submitRsvpSuccessSrc68Evid1601Params>
 */
export function submitRsvpSuccessSrc68Evid1601(params) {
    return { evid: 1601, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addGuestManuallyClick' event (evid: 161)
 *
 * Event description: user clicks to add guest manually
 *
 * @param {addGuestManuallyClickParams} params - The parameters for this event
 * @property {string} type_of_event - ticketed/rsvp
 * @property {GUID} event_id - []
 * @property {GUID} instance_id - []
 * @return {LogObject<addGuestManuallyClickParams>} LogObject<addGuestManuallyClickParams>
 */
export function addGuestManuallyClick(params) {
    return { evid: 161, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addGuestManuallySubmit' event (evid: 162)
 *
 * Event description: user submitted guest info
 *
 * @param {addGuestManuallySubmitParams} params - The parameters for this event
 * @property {string} ticket_status - {'not_paid', 'paid', 'free'}
 * @property {string} type_of_event - ticketed/rsvp
 * @property {boolean} send_ticket_pdf - true / false
 * @property {GUID} event_id - []
 * @property {GUID} instance_id - []
 * @property {string} rsvp_type - {'going', 'not_going', 'waitlist'}
 * @property {number} guests_count - guests_count
 * @return {LogObject<addGuestManuallySubmitParams>} LogObject<addGuestManuallySubmitParams>
 */
export function addGuestManuallySubmit(params) {
    return { evid: 162, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'registrationSettingsChanged' event (evid: 163)
 *
 * Event description: Registration tab:
 * Registration settings changed - to be sent on every 'save' click
 *
 * @param {registrationSettingsChangedParams} params - The parameters for this event
 * @property {string} rsvp_permission - value after save: {'all_visitors','site_members',NULL}
 * @property {string} registration_location - value after save: {'registration_page','external','no_registration'}
 * @property {string} registration_status - value after save: {'opened','closed','custom',NULL}
 * @property {DateTime} registration_opening_date - user selected opening date when registration status is 'custom'
 * @property {string} prev_registration_location - value before edit: {'registration_page','external','no_registration'}
 * @property {string} prev_registration_status - value before edit: {'opened','closed',NULL}
 * @property {string} guest_limit - value after save: {'unlimited','limited',NULL}
 * @property {DateTime} registration_closing_date - user selected closing date when registration status is 'custom'
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance id
 * @return {LogObject<registrationSettingsChangedParams>} LogObject<registrationSettingsChangedParams>
 */
export function registrationSettingsChanged(params) {
    return { evid: 163, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pagesModalOpened' event (evid: 164)
 *
 * Event description: Fired when the "View and customize your event pages" modal is opened
 *
 * @param {pagesModalOpenedParams} params - The parameters for this event
 * @property {string} origin - {'main_page_tab', 'main_page_footer', 'details_page_tab', 'registration_form_tab'}
 * @property {GUID} instance_id - instance id
 * @return {LogObject<pagesModalOpenedParams>} LogObject<pagesModalOpenedParams>
 */
export function pagesModalOpened(params) {
    return { evid: 164, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectMembershipIntent' event (evid: 165)
 *
 * Event description: connect membership Intent.
 *
 * @param {connectMembershipIntentParams} params - The parameters for this event
 * @property {string} type - {"connect","manage"}
 * @property {GUID} event_id - []
 * @property {GUID} instance_id - []
 * @return {LogObject<connectMembershipIntentParams>} LogObject<connectMembershipIntentParams>
 */
export function connectMembershipIntent(params) {
    return { evid: 165, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'saveMembership' event (evid: 166)
 *
 * Event description: User clicks on save in the Membership menu
 *
 * @param {saveMembershipParams} params - The parameters for this event
 * @property {GUID} event_id - []
 * @property {GUID} instance_id - []
 * @return {LogObject<saveMembershipParams>} LogObject<saveMembershipParams>
 */
export function saveMembership(params) {
    return { evid: 166, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'regionalSettingsClicked' event (evid: 167)
 *
 * Event description: Fired when user clicks the "Regional Settings" hint for changing the date & time formatting in event
 *
 * @param {regionalSettingsClickedParams} params - The parameters for this event
 * @property {string} origin - {'business_manager', 'app_settings_widget', 'app_settings_page'}
 * @property {GUID} instance_id - instance id
 * @return {LogObject<regionalSettingsClickedParams>} LogObject<regionalSettingsClickedParams>
 */
export function regionalSettingsClicked(params) {
    return { evid: 167, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventDetailsPageToggle' event (evid: 168)
 *
 * Event description: Fired when user toggles the "Show this page when visitors register" setting inside the Pages modal
 *
 * @param {eventDetailsPageToggleParams} params - The parameters for this event
 * @property {string} option - {'on', 'off'}
 * @property {GUID} instance_id - instance id
 * @return {LogObject<eventDetailsPageToggleParams>} LogObject<eventDetailsPageToggleParams>
 */
export function eventDetailsPageToggle(params) {
    return { evid: 168, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaDashboardDrillInClick' event (evid: 169)
 *
 * Event description: user click on one of the rows inside event manager dashboard
 *
 * @param {oaDashboardDrillInClickParams} params - The parameters for this event
 * @property {string} name - {guest_list,orders,event_promo}
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instanve_id
 * @return {LogObject<oaDashboardDrillInClickParams>} LogObject<oaDashboardDrillInClickParams>
 */
export function oaDashboardDrillInClick(params) {
    return { evid: 169, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaMemberEventsListFilter' event (evid: 172)
 *
 * Event description: user selects an events list filter in the member view
 *
 * @param {oaMemberEventsListFilterParams} params - The parameters for this event
 * @property {string} filter - {all_events, upcoming, going, past}
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaMemberEventsListFilterParams>} LogObject<oaMemberEventsListFilterParams>
 */
export function oaMemberEventsListFilter(params) {
    return { evid: 172, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createNewPolicyClick' event (evid: 173)
 *
 * Event description: create_new_policy_click
 *
 * @param {createNewPolicyClickParams} params - The parameters for this event
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<createNewPolicyClickParams>} LogObject<createNewPolicyClickParams>
 */
export function createNewPolicyClick(params) {
    return { evid: 173, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'savePolicyClick' event (evid: 174)
 *
 * Event description: save_policy_click
 *
 * @param {savePolicyClickParams} params - The parameters for this event
 * @property {boolean} is_first_save - is_first_save for the policy
 * @property {GUID} policy_id - policy_id - not available if it's the first save
 * @property {string} policy_name - Policy name
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<savePolicyClickParams>} LogObject<savePolicyClickParams>
 */
export function savePolicyClick(params) {
    return { evid: 174, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editPolicyClick' event (evid: 175)
 *
 * Event description: edit_policy_click.
 *
 * @param {editPolicyClickParams} params - The parameters for this event
 * @property {GUID} policy_id - policy_id
 * @property {string} policy_name - Policy name
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @property {string} action - reorder, edit, delete
 * @return {LogObject<editPolicyClickParams>} LogObject<editPolicyClickParams>
 */
export function editPolicyClick(params) {
    return { evid: 175, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deletePolicy' event (evid: 176)
 *
 * Event description: delete_policy
 *
 * @param {deletePolicyParams} params - The parameters for this event
 * @property {GUID} policy_id - policy_id
 * @property {string} policy_name - Policy name
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<deletePolicyParams>} LogObject<deletePolicyParams>
 */
export function deletePolicy(params) {
    return { evid: 176, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaEventsListSectionSaved' event (evid: 177)
 *
 * Event description: sent when user saves the events list section (Edit an existing one or save a new section)
 *
 * @param {oaEventsListSectionSavedParams} params - The parameters for this event
 * @property {boolean} guests_enabled - are guests enabled
 * @property {boolean} image_enabled - is image enabled
 * @property {string} recurring_event_type - 'individual events', 'one series of events'
 * @property {boolean} was_ticketed_button_text_changed - was the ticketed event button text string value changed
 * @property {boolean} was_section_title_changed - was the section title string value changed
 * @property {string} display_setting - {"upcoming_and_past","upcoming","manual"}
 * @property {boolean} membership_offer_enabled - is membership offer enabled
 * @property {boolean} event_date_enabled - is event date enabled
 * @property {boolean} was_rsvp_button_text_changed - was the rsvp event button text string value changed
 * @property {string} type - {"add","save"} either the section was added or edited
 * @property {GUID} instance_id - instance_id
 * @property {boolean} location_enabled - is location enabled
 * @property {boolean} is_section_title_on - is the section title toggled on
 * @return {LogObject<oaEventsListSectionSavedParams>} LogObject<oaEventsListSectionSavedParams>
 */
export function oaEventsListSectionSaved(params) {
    return { evid: 177, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaViewMyTickets' event (evid: 178)
 *
 * Event description: when a user opens the "My tickets" screen in OA
 *
 * @param {oaViewMyTicketsParams} params - The parameters for this event
 * @property {string} origin - {'purchase_success', 'my_event', 'my_orders', 'my_order_details'}
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaViewMyTicketsParams>} LogObject<oaViewMyTicketsParams>
 */
export function oaViewMyTickets(params) {
    return { evid: 178, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaPointOfSaleTransactionCompleteDoneClick' event (evid: 179)
 *
 * Event description: sent when user clicks "done" in the transaction complete screen of the POS flow
 *
 * @param {oaPointOfSaleTransactionCompleteDoneClickParams} params - The parameters for this event
 * @property {boolean} send_ticket_pdf - true / false
 * @property {boolean} arrived - true (check-in guests now ticked) / false
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaPointOfSaleTransactionCompleteDoneClickParams>} LogObject<oaPointOfSaleTransactionCompleteDoneClickParams>
 */
export function oaPointOfSaleTransactionCompleteDoneClick(params) {
    return { evid: 179, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaViewOrderInfo' event (evid: 180)
 *
 * Event description: Order Info page is opened
 *
 * @param {oaViewOrderInfoParams} params - The parameters for this event
 * @property {string} order_id - order_id
 * @property {string} origin - {'NOTIFICATION', 'ORDER_LIST'}
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaViewOrderInfoParams>} LogObject<oaViewOrderInfoParams>
 */
export function oaViewOrderInfo(params) {
    return { evid: 180, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'saveTicketSuccessSrc68Evid1800' event (evid: 1800)
 *
 * Event description: Firing when ticket definition is created or edited (editing existing or creating a new one)
 *
 * @param {saveTicketSuccessSrc68Evid1800Params} params - The parameters for this event
 * @property {boolean} hide_ticket - hide_ticket
 * @property {boolean} is_first_save - is_first_save
 * @property {string} ticket_fee_type - {'UNKNOWN_FEE_TYPE', 'FEE_INCLUDED', 'FEE_ADDED_AT_CHECKOUT', 'NO_FEE'}
 * @property {string} pricing_method - {'fixed_price', 'guest_price', 'pricing_options', 'free'}
 * @property {string} sale_status - sale_status
 * @property {DateTime} sale_opening_date - user selected opening date for when ticket is sold
 * @property {number} price - ticket price (null if free) - floats are not supported, so multiply by 100 before sending
 * @property {string} ticket_policy - ticket_policy
 * @property {GUID} meta_site_id - msid
 * @property {string} ticket_name - ticket_name
 * @property {string} pricing_options - json value for all pricing options
 * @property {string} currency - currency
 * @property {DateTime} sale_closing_date - user selected closing date for when ticket is sold
 * @property {number} ticket_quantity - ticket_quantity
 * @property {GUID} event_id - eveng_guid
 * @property {string} ticket_description - ticket_description
 * @property {GUID} ticket_definition_id - ticket_definition_id
 * @property {GUID} instanceId - instance_id
 * @return {LogObject<saveTicketSuccessSrc68Evid1800Params>} LogObject<saveTicketSuccessSrc68Evid1800Params>
 */
export function saveTicketSuccessSrc68Evid1800(params) {
    return { evid: 1800, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addRepeatingDatesForRecurringEvent' event (evid: 1801)
 *
 * Event description: User added recurring events with "add repeating dates". This bi event fires only when the user press "Add".
 *
 * @param {addRepeatingDatesForRecurringEventParams} params - The parameters for this event
 * @property {GUID} event_id - event guid
 * @property {DateTime} first_event_start_date - first_event_start_date
 * @property {DateTime} first_event_end_date - first_event_end_date
 * @property {boolean} show_timezone - show_timezone
 * @property {string} recurring_event_frequency - {‘Daily’,‘Weekly’,‘Every 2 weeks’,‘Monthly’,‘Custom’}
 * @property {string} repeats_every_period - {'Days','Months','Weeks'}
 * @property {number} repeats_every_number - repeats_every_number
 * @property {string} repeats_on - repeats_on
 * @property {string} end_of_recurring_events - {'On a specific date', 'After number of events'}
 * @property {DateTime} end_of_recurring_events_date - Only when the value of end_of_recurring_events is 'On a specific date'
 * @property {number} end_of_recurring_events_number - Only when the value of end_of_recurring_events is 'After number of events'
 * @property {boolean} is_valid - is_valid event
 * @property {number} count_of_events_added - count_of_events_added
 * @property {string} source_modal - {'repeating dates', 'specific dates'}
 * @return {LogObject<addRepeatingDatesForRecurringEventParams>} LogObject<addRepeatingDatesForRecurringEventParams>
 */
export function addRepeatingDatesForRecurringEvent(params) {
    return { evid: 1801, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'eventGuestListLoaded' event (evid: 1802)
 *
 * Event description: BI event fired when the event guest list is loaded. For both type of events - RSVP and Ticketed. Triggered only when the event has at least 1 guest. Not triggered on empty state.
 *
 * @param {eventGuestListLoadedParams} params - The parameters for this event
 * @property {GUID} event_id - event guid
 * @property {number} guests - number of guests loaded
 * @return {LogObject<eventGuestListLoadedParams>} LogObject<eventGuestListLoadedParams>
 */
export function eventGuestListLoaded(params) {
    return { evid: 1802, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaSelectTicketsSubmitClick' event (evid: 181)
 *
 * Event description: sent when a user clicks on "next" after selecting tickets in the "select tickets" screen in the ticket purchase flows
 *
 * @param {oaSelectTicketsSubmitClickParams} params - The parameters for this event
 * @property {number} ticket_count - null if no tickets allowed (absolute number of items purchased)
 * @property {number} nonfree_ticket_count - same as ticket_count, but for non-free tickets only
 * @property {string} origin - {'member_view', 'events_point_of_sale'}
 * @property {GUID} event_id - unique identifier for each Wix Event
 * @property {GUID} instance_id - instance_id (unique for each site)
 * @return {LogObject<oaSelectTicketsSubmitClickParams>} LogObject<oaSelectTicketsSubmitClickParams>
 */
export function oaSelectTicketsSubmitClick(params) {
    return { evid: 181, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouAddToCalendarClick' event (evid: 182)
 *
 * Event description: UoU clicks on the 'Add to Calendar' button in the thank you page
 *
 * @param {uouAddToCalendarClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} orderId - order number (null for rsvp events)
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event_id
 * @return {LogObject<uouAddToCalendarClickParams>} LogObject<uouAddToCalendarClickParams>
 */
export function uouAddToCalendarClick(params) {
    return { evid: 182, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaManageEventOptionsOpened' event (evid: 183)
 *
 * Event description: sent when owner opens the event options after tap on three dots
 *
 * @param {oaManageEventOptionsOpenedParams} params - The parameters for this event
 * @property {string} origin - {}
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaManageEventOptionsOpenedParams>} LogObject<oaManageEventOptionsOpenedParams>
 */
export function oaManageEventOptionsOpened(params) {
    return { evid: 183, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addScheduleItemClick' event (evid: 184)
 *
 * Event description: Triggered when "add item" button is clicked from the event details tab
 *
 * @param {addScheduleItemClickParams} params - The parameters for this event
 * @property {string} origin - {"event_details_tab","mobile_bo"}
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<addScheduleItemClickParams>} LogObject<addScheduleItemClickParams>
 */
export function addScheduleItemClick(params) {
    return { evid: 184, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scheduleItemSaveSuccess' event (evid: 185)
 *
 * Event description: Triggered when a new schedule item is added or an existing one was updated
 *
 * @param {scheduleItemSaveSuccessParams} params - The parameters for this event
 * @property {boolean} is_first_save - true for "add" and false for "update"
 * @property {boolean} is_description_added - true if the description is not empty
 * @property {GUID} schedule_item_id - schedule_item_id
 * @property {number} tag_count - the amount of tags added
 * @property {boolean} is_qna_enabled - true if user enabled q&a session.
 * @property {boolean} is_place_selected - true if a place for the item was set
 * @property {string} origin - {"event_details_tab","mobile_bo"}
 * @property {DateTime} item_end_date - item end date and time
 * @property {DateTime} item_start_date - item start date and time
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<scheduleItemSaveSuccessParams>} LogObject<scheduleItemSaveSuccessParams>
 */
export function scheduleItemSaveSuccess(params) {
    return { evid: 185, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editScheduleItemClick' event (evid: 186)
 *
 * Event description: Triggered when "edit" button is clicked for a schedule item
 *
 * @param {editScheduleItemClickParams} params - The parameters for this event
 * @property {GUID} schedule_item_id - schedule item guid
 * @property {string} origin - {"event_details_tab","mobile_bo"}
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<editScheduleItemClickParams>} LogObject<editScheduleItemClickParams>
 */
export function editScheduleItemClick(params) {
    return { evid: 186, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scheduleItemDeleteSuccess' event (evid: 187)
 *
 * Event description: Triggered when a schedule item is deleted
 *
 * @param {scheduleItemDeleteSuccessParams} params - The parameters for this event
 * @property {GUID} schedule_item_id - guid of schedule item
 * @property {string} origin - {"event_details_tab","mobile_bo"}
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<scheduleItemDeleteSuccessParams>} LogObject<scheduleItemDeleteSuccessParams>
 */
export function scheduleItemDeleteSuccess(params) {
    return { evid: 187, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scheduleItemVisibilityToggleClick' event (evid: 188)
 *
 * Event description: Triggered when a schedule item visibility is changed
 *
 * @param {scheduleItemVisibilityToggleClickParams} params - The parameters for this event
 * @property {GUID} schedule_item_id - schedule item guid
 * @property {string} origin - {"event_details_tab","mobile_bo"}
 * @property {boolean} flag - true - when an item is toggled to "show", false - when an item is toogled to 'hide'
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<scheduleItemVisibilityToggleClickParams>} LogObject<scheduleItemVisibilityToggleClickParams>
 */
export function scheduleItemVisibilityToggleClick(params) {
    return { evid: 188, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'schedulePageOpenClickInEditor' event (evid: 189)
 *
 * Event description: Triggered when a user clicks to open the schedule page in the editor
 *
 * @param {schedulePageOpenClickInEditorParams} params - The parameters for this event
 * @property {string} origin - {'page_panel', 'event_settings_page_tab'}
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<schedulePageOpenClickInEditorParams>} LogObject<schedulePageOpenClickInEditorParams>
 */
export function schedulePageOpenClickInEditor(params) {
    return { evid: 189, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaInviteMembersForScheduleBannerTap' event (evid: 190)
 *
 * Event description: triggered when the banner is tapped
 *
 * @param {oaInviteMembersForScheduleBannerTapParams} params - The parameters for this event
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaInviteMembersForScheduleBannerTapParams>} LogObject<oaInviteMembersForScheduleBannerTapParams>
 */
export function oaInviteMembersForScheduleBannerTap(params) {
    return { evid: 190, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouSchedulePageLoaded' event (evid: 191)
 *
 * Event description: triggered when UoU opens the schedule page
 *
 * @param {uouSchedulePageLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {string} origin - {'event_details_page', 'direct'}
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {number} schedule_item_count - the amount of items in the schedule
 * @property {GUID} event_id - event_id
 * @return {LogObject<uouSchedulePageLoadedParams>} LogObject<uouSchedulePageLoadedParams>
 */
export function uouSchedulePageLoaded(params) {
    return { evid: 191, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouSchedulePlaceFilterApplied' event (evid: 192)
 *
 * Event description: triggered when UoU applies a place filter on the schedule items
 *
 * @param {uouSchedulePlaceFilterAppliedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_place_filtered - whether place is filtered
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_tags_filtered - whether tags are filtered
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event_id
 * @return {LogObject<uouSchedulePlaceFilterAppliedParams>} LogObject<uouSchedulePlaceFilterAppliedParams>
 */
export function uouSchedulePlaceFilterApplied(params) {
    return { evid: 192, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouScheduleTagFilterApplied' event (evid: 193)
 *
 * Event description: sent when user sorts events by using dropdown button at BO
 *
 * @param {uouScheduleTagFilterAppliedParams} params - The parameters for this event
 * @property {string} sort_by_value - {'event_date','last_modified'}
 * @property {string} origin - draft_events, published_events
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouScheduleTagFilterAppliedParams>} LogObject<uouScheduleTagFilterAppliedParams>
 */
export function uouScheduleTagFilterApplied(params) {
    return { evid: 193, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouScheduleItemDescriptionView' event (evid: 194)
 *
 * Event description: triggered when UoU clicks on 'read more' on one of the schedule items
 *
 * @param {uouScheduleItemDescriptionViewParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} schedule_item_id - schedule item guid
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event_id
 * @return {LogObject<uouScheduleItemDescriptionViewParams>} LogObject<uouScheduleItemDescriptionViewParams>
 */
export function uouScheduleItemDescriptionView(params) {
    return { evid: 194, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaScheduleOpened' event (evid: 195)
 *
 * Event description: triggered when user opens the event schedule in OA from "see all" or "schedule" tab tap
 *
 * @param {oaScheduleOpenedParams} params - The parameters for this event
 * @property {string} origin - {'see_all', 'schedule_tab'}
 * @property {number} schedule_item_count - the amount of items in the schedule
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaScheduleOpenedParams>} LogObject<oaScheduleOpenedParams>
 */
export function oaScheduleOpened(params) {
    return { evid: 195, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaScheduleItemOpened' event (evid: 196)
 *
 * Event description: triggered when user opens the event schedule item in OA
 *
 * @param {oaScheduleItemOpenedParams} params - The parameters for this event
 * @property {GUID} schedule_item_id - guid of the schedule item
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaScheduleItemOpenedParams>} LogObject<oaScheduleItemOpenedParams>
 */
export function oaScheduleItemOpened(params) {
    return { evid: 196, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaAddToMyAgenda' event (evid: 197)
 *
 * Event description: triggered when user taps star on an agenda item
 *
 * @param {oaAddToMyAgendaParams} params - The parameters for this event
 * @property {GUID} schedule_item_id - guid of the schedule item
 * @property {boolean} flag - true for addition and false for removal
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaAddToMyAgendaParams>} LogObject<oaAddToMyAgendaParams>
 */
export function oaAddToMyAgenda(params) {
    return { evid: 197, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaViewMyAgenda' event (evid: 198)
 *
 * Event description: triggered when user taps "my agenda"
 *
 * @param {oaViewMyAgendaParams} params - The parameters for this event
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaViewMyAgendaParams>} LogObject<oaViewMyAgendaParams>
 */
export function oaViewMyAgenda(params) {
    return { evid: 198, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaSchedulePlaceFilterApplied' event (evid: 199)
 *
 * Event description: triggered when a user applies a place filter on the schedule items
 *
 * @param {oaSchedulePlaceFilterAppliedParams} params - The parameters for this event
 * @property {boolean} is_place_filtered - whether place is filtered
 * @property {boolean} is_tags_filtered - whether the tags are filtered
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaSchedulePlaceFilterAppliedParams>} LogObject<oaSchedulePlaceFilterAppliedParams>
 */
export function oaSchedulePlaceFilterApplied(params) {
    return { evid: 199, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'feesEmailAttemptSrc68Evid2' event (evid: 2)
 *
 * Event description: Fees email attempt
 *
 * @param {feesEmailAttemptSrc68Evid2Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} msid - msid
 * @property {string} notificationId - notificationId
 * @return {LogObject<feesEmailAttemptSrc68Evid2Params>} LogObject<feesEmailAttemptSrc68Evid2Params>
 */
export function feesEmailAttemptSrc68Evid2(params) {
    return { evid: 2, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'regFormFieldAdded' event (evid: 20)
 *
 * Event description: Choosing a new registration form field by Site owner.
 *
 * @param {regFormFieldAddedParams} params - The parameters for this event
 * @property {number} total_guests_count - total_guests_count
 * @property {number} waiting_list_guest_count - waiting_list_guest_count
 * @property {string} tab_name - {'event_details, 'event_reg', invitations', 'guest_list'}
 * @property {number} confirmed_guests_count - confirmed_guests_count
 * @property {boolean} is_demo_data - is_demo_data
 * @property {number} event_capacity - event_capacity
 * @property {number} questions_count - questions_count
 * @property {string} button_name - {'phone', 'address', 'date', 'additional_guest', 'comment', 'custom'}
 * @property {string} event_name - event_name
 * @property {string} event_timezone - event_timezone
 * @property {DateTime} event_start_date - event_start_date
 * @property {number} declined_guests_count - declined_guests_count
 * @property {number} num_characters - number of characters in field's question/checkbox
 * @property {string} comp_id - comp_id
 * @property {boolean} is_first_event - bool - hardcoded TRUE until we implement multiple events feature
 * @property {DateTime} event_finish_date - event_finish_date
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @property {string} event_location - event_location
 * @return {LogObject<regFormFieldAddedParams>} LogObject<regFormFieldAddedParams>
 */
export function regFormFieldAdded(params) {
    return { evid: 20, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoWaittingScreenLoaded' event (evid: 201)
 *
 * Event description: User clicked on a banner.
 *
 * @param {uouLiveVideoWaittingScreenLoadedParams} params - The parameters for this event
 * @property {string} banner_name - {'corona','one_app','wix_live_article','owner_event_guidebook_for_members_app'}
 * @property {string} origin - banner's location {'guest_list','my_events','check_ins','oa_my_events'}
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouLiveVideoWaittingScreenLoadedParams>} LogObject<uouLiveVideoWaittingScreenLoadedParams>
 */
export function uouLiveVideoWaittingScreenLoaded(params) {
    return { evid: 201, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoMicrophoneToggle' event (evid: 202)
 *
 * Event description: Fired after user adds events to a category and clicks confirm
 *
 * @param {uouLiveVideoMicrophoneToggleParams} params - The parameters for this event
 * @property {number} count_of_added_events - count of added events
 * @property {string} category_name - category_name
 * @property {GUID} category_guid - category_guid
 * @property {number} count_of_total_events - count of total events after changes
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouLiveVideoMicrophoneToggleParams>} LogObject<uouLiveVideoMicrophoneToggleParams>
 */
export function uouLiveVideoMicrophoneToggle(params) {
    return { evid: 202, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoChangeLayout' event (evid: 204)
 *
 * Event description: User clicked on create category
 *
 * @param {uouLiveVideoChangeLayoutParams} params - The parameters for this event
 * @property {string} button_name - {"add_category_box", "add_category"}
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouLiveVideoChangeLayoutParams>} LogObject<uouLiveVideoChangeLayoutParams>
 */
export function uouLiveVideoChangeLayout(params) {
    return { evid: 204, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoRejoinClick' event (evid: 206)
 *
 * Event description: Fired after user removed events from a category and clicks confirm
 *
 * @param {uouLiveVideoRejoinClickParams} params - The parameters for this event
 * @property {string} category_name - category_name
 * @property {number} count_of_removed_events - count of removed events
 * @property {GUID} category_guid - category_guid
 * @property {number} count_of_total_events - count of total events after changes
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouLiveVideoRejoinClickParams>} LogObject<uouLiveVideoRejoinClickParams>
 */
export function uouLiveVideoRejoinClick(params) {
    return { evid: 206, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoChatMessagePublish' event (evid: 207)
 *
 * Event description: User clicked on preview draft from Draft events section. Toast clicks replaced by 68:223 with ToastName='preview_event'
 *
 * @param {uouLiveVideoChatMessagePublishParams} params - The parameters for this event
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouLiveVideoChatMessagePublishParams>} LogObject<uouLiveVideoChatMessagePublishParams>
 */
export function uouLiveVideoChatMessagePublish(params) {
    return { evid: 207, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoChatScreenToggle' event (evid: 208)
 *
 * Event description: User clicks one of the available buttons to publish event draft. Origin added 2021-07-15, before that NULL values refer to 'event_card'
 *
 * @param {uouLiveVideoChatScreenToggleParams} params - The parameters for this event
 * @property {boolean} is_modal - true if the user got the modal to confirm event publishing
 * @property {string} origin - {'event_card','event_details'}
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouLiveVideoChatScreenToggleParams>} LogObject<uouLiveVideoChatScreenToggleParams>
 */
export function uouLiveVideoChatScreenToggle(params) {
    return { evid: 208, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoSettingsToggle' event (evid: 210)
 *
 * Event description: click on "dont delete" or "delete draft" at delete event popup message
 *
 * @param {uouLiveVideoSettingsToggleParams} params - The parameters for this event
 * @property {string} button_name - {"dont delete","delete draft"}
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouLiveVideoSettingsToggleParams>} LogObject<uouLiveVideoSettingsToggleParams>
 */
export function uouLiveVideoSettingsToggle(params) {
    return { evid: 210, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoShareScreenToggle' event (evid: 211)
 *
 * Event description: user toggles one of the toggles in the Emails tab of the event page
 *
 * @param {uouLiveVideoShareScreenToggleParams} params - The parameters for this event
 * @property {string} toggle_status - {'on', 'off'}
 * @property {string} toggle_name - {'confirmation','reminder','cancelation','invoices'}
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouLiveVideoShareScreenToggleParams>} LogObject<uouLiveVideoShareScreenToggleParams>
 */
export function uouLiveVideoShareScreenToggle(params) {
    return { evid: 211, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoLeaveClick' event (evid: 212)
 *
 * Event description: user clicks the "Customize" button in the Emails tab, Invoices section.
 *
 * @param {uouLiveVideoLeaveClickParams} params - The parameters for this event
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouLiveVideoLeaveClickParams>} LogObject<uouLiveVideoLeaveClickParams>
 */
export function uouLiveVideoLeaveClick(params) {
    return { evid: 212, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoParticipantsListToggle' event (evid: 213)
 *
 * Event description: User clicks the available suggested action
 *
 * @param {uouLiveVideoParticipantsListToggleParams} params - The parameters for this event
 * @property {string} button_name - suggested action name
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouLiveVideoParticipantsListToggleParams>} LogObject<uouLiveVideoParticipantsListToggleParams>
 */
export function uouLiveVideoParticipantsListToggle(params) {
    return { evid: 213, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoGoToSiteClick' event (evid: 214)
 *
 * Event description: Fires whenever user clicks on one of the Learn More links available in the app
 *
 * @param {uouLiveVideoGoToSiteClickParams} params - The parameters for this event
 * @property {string} button_name - {'zoom_setup','wixlive_setup','owner_event_guidebook_for_members_app'}
 * @property {string} origin - {'conference_setup','oa_my_events'}
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uouLiveVideoGoToSiteClickParams>} LogObject<uouLiveVideoGoToSiteClickParams>
 */
export function uouLiveVideoGoToSiteClick(params) {
    return { evid: 214, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoGivePermissionsClick' event (evid: 215)
 *
 * Event description: UoU clicks one of the buttons available in the modal for iOS exception.
 *
 * @param {userLiveVideoGivePermissionsClickParams} params - The parameters for this event
 * @property {string} origin - {'payment_unavailable'}
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @property {string} action - {'close','send message'}
 * @return {LogObject<userLiveVideoGivePermissionsClickParams>} LogObject<userLiveVideoGivePermissionsClickParams>
 */
export function userLiveVideoGivePermissionsClick(params) {
    return { evid: 215, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoShareScreenToggle' event (evid: 216)
 *
 * Event description: UoU bookmarks one of the items available
 *
 * @param {userLiveVideoShareScreenToggleParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} schedule_item_id - scheduled item's id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {string} origin - {'schedule','item details','my agenda'}
 * @property {string} status - {'on','off'}
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event_id
 * @return {LogObject<userLiveVideoShareScreenToggleParams>} LogObject<userLiveVideoShareScreenToggleParams>
 */
export function userLiveVideoShareScreenToggle(params) {
    return { evid: 216, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoChangeLayoutClick' event (evid: 217)
 *
 * Event description: UoU clicks on the 'view my agenda' button for schedule items to view 'my agenda' modal.
 *
 * @param {userLiveVideoChangeLayoutClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} schedule_item_id - schedule item id, if clicked from item details. Else NULL
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {string} origin - {'schedule','item details'}
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event id
 * @return {LogObject<userLiveVideoChangeLayoutClickParams>} LogObject<userLiveVideoChangeLayoutClickParams>
 */
export function userLiveVideoChangeLayoutClick(params) {
    return { evid: 217, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoChatOpened' event (evid: 218)
 *
 * Event description: UoU clicks on one of the buttons available for login/logout. Will not generate an entry if the area belongs to Members Area
 *
 * @param {userLiveVideoChatOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} button_name - {'login','logout'}
 * @property {number} event_rank - event_rank
 * @property {string} origin - {'schedule','item details'}
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event_id if applicable
 * @return {LogObject<userLiveVideoChatOpenedParams>} LogObject<userLiveVideoChatOpenedParams>
 */
export function userLiveVideoChatOpened(params) {
    return { evid: 218, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoChatMessagePublish' event (evid: 219)
 *
 * Event description: clicks associated with Group integration in Events. Now only accessible from the bottom fo the Event Details page.
 *
 * @param {userLiveVideoChatMessagePublishParams} params - The parameters for this event
 * @property {string} button_name - {'connect_group','manage_group','disconnect_group'}
 * @property {string} userEntry - {'bizmngr','one_app'}
 * @property {string} origin - {'event_card','event_details','event_dashboard'}
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<userLiveVideoChatMessagePublishParams>} LogObject<userLiveVideoChatMessagePublishParams>
 */
export function userLiveVideoChatMessagePublish(params) {
    return { evid: 219, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoStartVideoClick' event (evid: 220)
 *
 * Event description: Ticket added to apple wallet
 *
 * @param {userLiveVideoStartVideoClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event_guid
 * @return {LogObject<userLiveVideoStartVideoClickParams>} LogObject<userLiveVideoStartVideoClickParams>
 */
export function userLiveVideoStartVideoClick(params) {
    return { evid: 220, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoChatActionClicked' event (evid: 221)
 *
 * Event description: User clicks "continue" on the modal that allows to be redirected to email marketing to email guests about the changes made in the event.
 *
 * @param {userLiveVideoChatActionClickedParams} params - The parameters for this event
 * @property {string} template_name - 'event_update_location', 'event_update_date', 'event_update_location_date', 'event_update_schedule'
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<userLiveVideoChatActionClickedParams>} LogObject<userLiveVideoChatActionClickedParams>
 */
export function userLiveVideoChatActionClicked(params) {
    return { evid: 221, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLiveVideoMicrophoneToggleSrc68Evid222' event (evid: 222)
 *
 * Event description: User clicks on the reorder button and potentially drags one of the tickets to a new position
 *
 * @param {uouLiveVideoMicrophoneToggleSrc68Evid222Params} params - The parameters for this event
 * @property {boolean} ticket_reordered - true if the click resulted in the change of order of tickets
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @property {GUID} ticket_definition_id - unique identifier of each ticket (name, not a single UoU ticket)
 * @return {LogObject<uouLiveVideoMicrophoneToggleSrc68Evid222Params>} LogObject<uouLiveVideoMicrophoneToggleSrc68Evid222Params>
 */
export function uouLiveVideoMicrophoneToggleSrc68Evid222(params) {
    return { evid: 222, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoCameraToggle' event (evid: 223)
 *
 * Event description: User clicks one of the available toasts.
 *
 * @param {userLiveVideoCameraToggleParams} params - The parameters for this event
 * @property {string} origin - location of the toast {'event_details','draft_event_list'}
 * @property {string} toastName - identifier of the type of toast clicked {'create_ticket,''notify_guests','preview_event'}
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<userLiveVideoCameraToggleParams>} LogObject<userLiveVideoCameraToggleParams>
 */
export function userLiveVideoCameraToggle(params) {
    return { evid: 223, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoReactionsOpened' event (evid: 224)
 *
 * Event description: User saves changes for the tickets unavailable message (ticketed event)
 *
 * @param {userLiveVideoReactionsOpenedParams} params - The parameters for this event
 * @property {string} button_text - text used for the button
 * @property {string} message_text - text used for the message
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<userLiveVideoReactionsOpenedParams>} LogObject<userLiveVideoReactionsOpenedParams>
 */
export function userLiveVideoReactionsOpened(params) {
    return { evid: 224, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoParticipantsListOpened' event (evid: 225)
 *
 * Event description: User saves changes for the registration closed message
 *
 * @param {userLiveVideoParticipantsListOpenedParams} params - The parameters for this event
 * @property {string} button_text - text used for the button
 * @property {string} message_text - text used for the message
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<userLiveVideoParticipantsListOpenedParams>} LogObject<userLiveVideoParticipantsListOpenedParams>
 */
export function userLiveVideoParticipantsListOpened(params) {
    return { evid: 225, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoParticipantsActionClicked' event (evid: 226)
 *
 * Event description: User saves changes for the thank you message (rsvp only)
 *
 * @param {userLiveVideoParticipantsActionClickedParams} params - The parameters for this event
 * @property {boolean} allow_guest_calendar - user ticks availability for the uou to add the event to their calendar
 * @property {string} calendar_text - text used for adding to calendar button
 * @property {string} message_text - text used for the message
 * @property {string} title_text - text used for the title
 * @property {boolean} allow_guest_sharing - users ticks availability for the uou to share the event through social media
 * @property {string} share_text - text used for sharing the event through social media
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<userLiveVideoParticipantsActionClickedParams>} LogObject<userLiveVideoParticipantsActionClickedParams>
 */
export function userLiveVideoParticipantsActionClicked(params) {
    return { evid: 226, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaScheduleSectionSaved' event (evid: 227)
 *
 * Event description: sent when user saves the schedule section (Edit an existing one or save a new section)
 *
 * @param {oaScheduleSectionSavedParams} params - The parameters for this event
 * @property {string} type - {"add","save"} either the section was added or edited
 * @property {GUID} event_id - event_guid of the event that was selected
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaScheduleSectionSavedParams>} LogObject<oaScheduleSectionSavedParams>
 */
export function oaScheduleSectionSaved(params) {
    return { evid: 227, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoEndVideoClick' event (evid: 229)
 *
 * Event description: UoU clicks 'Join' in the Groups section of the thank you page after confirming rsvp/buying a ticket.
 *
 * @param {userLiveVideoEndVideoClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} group_id - group_id
 * @property {GUID} biToken - msid
 * @property {GUID} orderId - order number; null if RSVP
 * @property {GUID} visitor_id - visitor_id indicating unique UoU
 * @property {number} event_rank - event_rank
 * @property {string} origin - {'thankyou_page'}
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event_id
 * @return {LogObject<userLiveVideoEndVideoClickParams>} LogObject<userLiveVideoEndVideoClickParams>
 */
export function userLiveVideoEndVideoClick(params) {
    return { evid: 229, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoHostScreenLoaded' event (evid: 230)
 *
 * Event description: user event fired when user loads the host screen
 *
 * @param {userLiveVideoHostScreenLoadedParams} params - The parameters for this event
 * @property {string} buttonStatus - {'on','off'}
 * @property {string} button_name - {'rsvp','read_more','members_going','about_section','schedule','map','social_sharing','date_location','description'}
 * @property {string} page_name - {'event_details','home'}
 * @property {string} origin - {'display'}
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<userLiveVideoHostScreenLoadedParams>} LogObject<userLiveVideoHostScreenLoadedParams>
 */
export function userLiveVideoHostScreenLoaded(params) {
    return { evid: 230, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoStartRecordVideoSrc68Evid231' event (evid: 231)
 *
 * Event description: User sets up how events will be displayed from settings panel (my events) in Editor
 *
 * @param {userLiveVideoStartRecordVideoSrc68Evid231Params} params - The parameters for this event
 * @property {string} events_shown - {'selected_manually','upcoming_past','upcoming','past'}
 * @property {string} buttonStatus - {'single','multiple'}
 * @property {string} recurring_shown - {'one',''individual'}
 * @property {string} category_id - id of the category used for filter. If null, all events are selected
 * @property {GUID} event_id - event id. Shown if user selects Single Event and the event in question represented by the id.
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<userLiveVideoStartRecordVideoSrc68Evid231Params>} LogObject<userLiveVideoStartRecordVideoSrc68Evid231Params>
 */
export function userLiveVideoStartRecordVideoSrc68Evid231(params) {
    return { evid: 231, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'userLiveVideoStopRecordVideo' event (evid: 232)
 *
 * Event description: User receives a modal after fulfilling it's condition
 *
 * @param {userLiveVideoStopRecordVideoParams} params - The parameters for this event
 * @property {string} modal_name - {'schedule_items_ticket_sale_periods_removed','ticket_sale_periods_removed','scheduled_items_removed','custom_registration_dates_removed','schedule_items_custom_registration_dates_removed'}
 * @property {string} origin - location of the modal 'registration_settings', 'edit_ticket', 'event_details'
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance id
 * @property {GUID} ticket_definition_id - ticket id, null if not relevant
 * @return {LogObject<userLiveVideoStopRecordVideoParams>} LogObject<userLiveVideoStopRecordVideoParams>
 */
export function userLiveVideoStopRecordVideo(params) {
    return { evid: 232, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaGuestListSectionSaved' event (evid: 233)
 *
 * Event description: sent when user saves the guest list section (Edit an existing one or save a new section)
 *
 * @param {oaGuestListSectionSavedParams} params - The parameters for this event
 * @property {string} type - {"add","save"} either the section was added or edited
 * @property {GUID} event_id - event_guid of the event that was selected
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaGuestListSectionSavedParams>} LogObject<oaGuestListSectionSavedParams>
 */
export function oaGuestListSectionSaved(params) {
    return { evid: 233, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaDiscussionSectionSaved' event (evid: 234)
 *
 * Event description: sent when user saves the discussion section (Edit an existing one or save a new section)
 *
 * @param {oaDiscussionSectionSavedParams} params - The parameters for this event
 * @property {string} type - {"add","save"} either the section was added or edited
 * @property {GUID} event_id - event_guid of the event that was selected
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaDiscussionSectionSavedParams>} LogObject<oaDiscussionSectionSavedParams>
 */
export function oaDiscussionSectionSaved(params) {
    return { evid: 234, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editCategoryClick' event (evid: 235)
 *
 * Event description: user edited a category
 *
 * @param {editCategoryClickParams} params - The parameters for this event
 * @property {string} new_name - new_name
 * @property {GUID} category_guid - category_guid
 * @property {string} previous_name - previous_name
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<editCategoryClickParams>} LogObject<editCategoryClickParams>
 */
export function editCategoryClick(params) {
    return { evid: 235, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteCategoryClick' event (evid: 236)
 *
 * Event description: Clicking on (confirming) deleting Category (in popup)
 *
 * @param {deleteCategoryClickParams} params - The parameters for this event
 * @property {string} category_name - category_name
 * @property {string} button_name - {"delete"}
 * @property {GUID} category_guid - category_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<deleteCategoryClickParams>} LogObject<deleteCategoryClickParams>
 */
export function deleteCategoryClick(params) {
    return { evid: 236, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'filterEventsByCategoryClick' event (evid: 237)
 *
 * Event description: sent when user filters events' list by using one of the available filters at BO
 *
 * @param {filterEventsByCategoryClickParams} params - The parameters for this event
 * @property {string} filterValue - filter value
 * @property {string} category_name - category name; null if a filter other than categories was used
 * @property {string} filter_name - filter_name
 * @property {string} origin - page where the filter is applied. Example draft, published
 * @property {GUID} category_guid - category guid; null if a filter other than categories was used
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<filterEventsByCategoryClickParams>} LogObject<filterEventsByCategoryClickParams>
 */
export function filterEventsByCategoryClick(params) {
    return { evid: 237, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'scheduleItemCancelSuccess' event (evid: 238)
 *
 * Event description: Triggered when the user confirms schedule item cancellation
 *
 * @param {scheduleItemCancelSuccessParams} params - The parameters for this event
 * @property {GUID} schedule_item_id - schedule_item_id
 * @property {string} origin - {"event_details_tab","mobile_bo"}
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<scheduleItemCancelSuccessParams>} LogObject<scheduleItemCancelSuccessParams>
 */
export function scheduleItemCancelSuccess(params) {
    return { evid: 238, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'downloadTicketIntent' event (evid: 239)
 *
 * Event description: UoU shows interest in downloading ticket.
 * For mobile web, clicking 'Download Ticket' button from thank you page.
 *
 * @param {downloadTicketIntentParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor id
 * @property {number} event_rank - event_rank
 * @property {string} origin - {'thank you page'}
 * @property {boolean} show_image - show_image
 * @property {boolean} is_mobile - True if UoU is making the action from mobile web, else False.
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event id
 * @return {LogObject<downloadTicketIntentParams>} LogObject<downloadTicketIntentParams>
 */
export function downloadTicketIntent(params) {
    return { evid: 239, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'modalSelectionConfirmation' event (evid: 240)
 *
 * Event description: User clicks one of the buttons available on the pop'ed modal
 *
 * @param {modalSelectionConfirmationParams} params - The parameters for this event
 * @property {string} button_name - {'cancel','continue','x','save','dont_save'}
 * @property {string} modal_name - {'schedule_items_ticket_sale_periods_removed','ticket_sale_periods_removed','scheduled_items_removed','custom_registration_dates_removed'}
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<modalSelectionConfirmationParams>} LogObject<modalSelectionConfirmationParams>
 */
export function modalSelectionConfirmation(params) {
    return { evid: 240, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bannerTrigger' event (evid: 241)
 *
 * Event description: User receives a banner after fulfilling it's condition
 *
 * @param {bannerTriggerParams} params - The parameters for this event
 * @property {string} banner_name - {'corona','one_app','wix_live_article','owner_event_guidebook_for_members_app','registration_settings'}
 * @property {string} origin - banner's location {'guest_list','my_events','check_ins','oa_my_events'}
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<bannerTriggerParams>} LogObject<bannerTriggerParams>
 */
export function bannerTrigger(params) {
    return { evid: 241, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketFilterApplied' event (evid: 242)
 *
 * Event description: User selects one of the filter options on the ticket list page
 *
 * @param {ticketFilterAppliedParams} params - The parameters for this event
 * @property {string} filterValue - name of the selected filter
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<ticketFilterAppliedParams>} LogObject<ticketFilterAppliedParams>
 */
export function ticketFilterApplied(params) {
    return { evid: 242, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uiElementClick' event (evid: 243)
 *
 * Event description: Measure a user's interaction with different elements of the user interface.
 *
 * @param {uiElementClickParams} params - The parameters for this event
 * @property {string} name - {'draft_event_status'}
 * @property {GUID} event_id - event guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<uiElementClickParams>} LogObject<uiElementClickParams>
 */
export function uiElementClick(params) {
    return { evid: 243, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'liveVideoButtonClick' event (evid: 244)
 *
 * Event description: user clicks one of the buttons dedicated to setting up live video (wix live) on their event inside Events BO
 *
 * @param {liveVideoButtonClickParams} params - The parameters for this event
 * @property {string} button_name - {'manage_live_video','disconnect','turn_off_toggle'}
 * @property {string} origin - {'my_events','event_details'}
 * @property {GUID} event_id - event guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<liveVideoButtonClickParams>} LogObject<liveVideoButtonClickParams>
 */
export function liveVideoButtonClick(params) {
    return { evid: 244, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'registrationSettingsClick' event (evid: 245)
 *
 * Event description: User clicks on one of the available registration settings elements
 *
 * @param {registrationSettingsClickParams} params - The parameters for this event
 * @property {string} element_name - {'open','closed','custom_dates','registration_page','external','no_registration','limited_guests','unlimited_guests','close_registration','add_to_waitlist'}
 * @property {string} origin - {'guest_registration','guest_limit'}
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<registrationSettingsClickParams>} LogObject<registrationSettingsClickParams>
 */
export function registrationSettingsClick(params) {
    return { evid: 245, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editTicketClick' event (evid: 246)
 *
 * Event description: User clicks on one of the available edit ticket elements
 *
 * @param {editTicketClickParams} params - The parameters for this event
 * @property {string} element_name - {'for_sale','free','limit_quantity','ticket_sale_period'}
 * @property {string} form_origin - {'seatings modal','events'}
 * @property {string} pricing_options - json value for all pricing options
 * @property {string} origin - {'ticket_type','advanced_settings'}
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} ticket_definition_id - ticket_definition_id
 * @return {LogObject<editTicketClickParams>} LogObject<editTicketClickParams>
 */
export function editTicketClick(params) {
    return { evid: 246, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createSeatingMapClick' event (evid: 247)
 *
 * Event description: Use clicks one of the available buttons to start creating a seating map. origin='seating_modal' identifies creation after template was selected.
 *
 * @param {createSeatingMapClickParams} params - The parameters for this event
 * @property {string} origin - {'empty_state','card','seating_modal'}
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<createSeatingMapClickParams>} LogObject<createSeatingMapClickParams>
 */
export function createSeatingMapClick(params) {
    return { evid: 247, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selectSeatingMapClick' event (evid: 248)
 *
 * Event description: User selects on one of the available map templates during the seating map setup process
 *
 * @param {selectSeatingMapClickParams} params - The parameters for this event
 * @property {string} name - {'start_from_scratch','mixed_seating','rows','tables','custom'} custom if user's custom layout is selected
 * @property {GUID} seating_map_guid - ID of the seating map from which the layout was copied; null if user selects a generic template
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<selectSeatingMapClickParams>} LogObject<selectSeatingMapClickParams>
 */
export function selectSeatingMapClick(params) {
    return { evid: 248, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingMapActionClick' event (evid: 249)
 *
 * Event description: User clicks on one of the available action buttons of the seating map
 *
 * @param {seatingMapActionClickParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating map id
 * @property {GUID} event_id - event guid
 * @property {GUID} instance_id - instance_id
 * @property {string} action - {'preview','remove','manage_edit'}
 * @return {LogObject<seatingMapActionClickParams>} LogObject<seatingMapActionClickParams>
 */
export function seatingMapActionClick(params) {
    return { evid: 249, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingMapSaveClick' event (evid: 250)
 *
 * Event description: User confirms a map's deletion in the modal window
 *
 * @param {seatingMapSaveClickParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating map id
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<seatingMapSaveClickParams>} LogObject<seatingMapSaveClickParams>
 */
export function seatingMapSaveClick(params) {
    return { evid: 250, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouSeatingMapTicketSelectionClick' event (evid: 251)
 *
 * Event description: User selects or removes an available seat from the map or ticket list
 *
 * @param {uouSeatingMapTicketSelectionClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} seat_guid - unique seat id, null if whole table reservation is required
 * @property {GUID} biToken - msid
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} event_guid - event id
 * @property {number} event_rank - event_rank
 * @property {string} element_guid - element id
 * @property {string} origin - {'map','ticket_list','basket'}
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {boolean} is_whole_table - true if the selected element required whole table reservation
 * @property {string} element_type - element type
 * @property {string} action - {'select','delete'}
 * @return {LogObject<uouSeatingMapTicketSelectionClickParams>} LogObject<uouSeatingMapTicketSelectionClickParams>
 */
export function uouSeatingMapTicketSelectionClick(params) {
    return { evid: 251, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouSeatingMapTabOpened' event (evid: 252)
 *
 * Event description: UoU opens one of the tabs available in the ticket selection
 *
 * @param {uouSeatingMapTabOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {'basket','ticket_list'}
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} event_guid - event id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @return {LogObject<uouSeatingMapTabOpenedParams>} LogObject<uouSeatingMapTabOpenedParams>
 */
export function uouSeatingMapTabOpened(params) {
    return { evid: 252, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouSeatingMapTicketListFilterApplied' event (evid: 253)
 *
 * Event description: uou_seating_map_ticket_list_filter_applied.
 *
 * @param {uouSeatingMapTicketListFilterAppliedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} filterValue - value selected for the filter
 * @property {GUID} biToken - msid
 * @property {GUID} seating_map_guid - seating id
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {string} filter_name - {'price','zone','refresh_filters'}
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event id
 * @return {LogObject<uouSeatingMapTicketListFilterAppliedParams>} LogObject<uouSeatingMapTicketListFilterAppliedParams>
 */
export function uouSeatingMapTicketListFilterApplied(params) {
    return { evid: 253, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouSeatingMapButtonClick' event (evid: 254)
 *
 * Event description: UoU clicks one of the available buttons in the map section of the ticket selector
 *
 * @param {uouSeatingMapButtonClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} seating_map_guid - seating id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} button_name - {'show_prices','hide_prices','zoom_in','zoom_out'}
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event_guid
 * @return {LogObject<uouSeatingMapButtonClickParams>} LogObject<uouSeatingMapButtonClickParams>
 */
export function uouSeatingMapButtonClick(params) {
    return { evid: 254, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingMapCreationSuccess' event (evid: 255)
 *
 * Event description: Successful creation of a seating map from Event's back office
 *
 * @param {seatingMapCreationSuccessParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<seatingMapCreationSuccessParams>} LogObject<seatingMapCreationSuccessParams>
 */
export function seatingMapCreationSuccess(params) {
    return { evid: 255, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorEventsWidgetSettingChanged' event (evid: 256)
 *
 * Event description: When user changes a setting in the events widget inside editor.
 *
 * @param {editorEventsWidgetSettingChangedParams} params - The parameters for this event
 * @property {string} widget_type - e.g. wix events, event details
 * @property {string} editor_working_mode - editor_working_mode
 * @property {string} comp_id - comp_id
 * @property {string} setting_name - e.g. layout, spacing, allow additional info
 * @property {GUID} instance_id - instance_id
 * @property {string} value - toggle states - e.g. true/false. Layout types e.g. grid, list, calendar. Numerical value of a slider e.g.  3, 10, 16
 * @return {LogObject<editorEventsWidgetSettingChangedParams>} LogObject<editorEventsWidgetSettingChangedParams>
 */
export function editorEventsWidgetSettingChanged(params) {
    return { evid: 256, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorEventsWidgetSettingNavigate' event (evid: 257)
 *
 * Event description: When user navigates through tabs in events widgets settings.
 *
 * @param {editorEventsWidgetSettingNavigateParams} params - The parameters for this event
 * @property {string} tab_name - e.g. design-ribbonDesign-membershipRibbonDesign
 * @property {string} widget_type - Wix events, Event details
 * @property {string} previous_tab - e.g. design-ribbonDesign
 * @property {string} editor_working_mode - editor_working_mode
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<editorEventsWidgetSettingNavigateParams>} LogObject<editorEventsWidgetSettingNavigateParams>
 */
export function editorEventsWidgetSettingNavigate(params) {
    return { evid: 257, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'featureEditClick' event (evid: 258)
 *
 * Event description: User clicks on the Edit button from one of the available features on an Events from the Registration/Emails tab
 *
 * @param {featureEditClickParams} params - The parameters for this event
 * @property {string} featureName - name of the feature whose Edit button is clicked
 * @property {string} tab_name - name of the tab in which the feature is present
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<featureEditClickParams>} LogObject<featureEditClickParams>
 */
export function featureEditClick(params) {
    return { evid: 258, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaEventsListSettingsSaved' event (evid: 259)
 *
 * Event description: User saves events list settings within OA.
 *
 * @param {oaEventsListSettingsSavedParams} params - The parameters for this event
 * @property {boolean} guests_enabled - are guests enabled
 * @property {string} display_type - 'upcoming and past', 'upcoming;, 'manually select'
 * @property {boolean} image_enabled - is event image enabled
 * @property {string} recurring_event_type - 'individual events', 'one series of events'
 * @property {boolean} section_title_enabled - is section title enabled
 * @property {boolean} event_date_enabled - is event date enabled
 * @property {GUID} instance_id - instance_id
 * @property {boolean} location_enabled - is location enabled
 * @return {LogObject<oaEventsListSettingsSavedParams>} LogObject<oaEventsListSettingsSavedParams>
 */
export function oaEventsListSettingsSaved(params) {
    return { evid: 259, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaEventDetailsSettingsSaved' event (evid: 260)
 *
 * Event description: User saved settings of event details.
 *
 * @param {oaEventDetailsSettingsSavedParams} params - The parameters for this event
 * @property {boolean} guests_enabled - are guests enabled
 * @property {boolean} schedule_enabled - is schedule enabled
 * @property {boolean} image_enabled - is image enabled
 * @property {boolean} map_enabled - is map enabled
 * @property {boolean} membership_offer_enabled - is membership offer enabled
 * @property {boolean} event_date_enabled - is event date enabled
 * @property {GUID} instance_id - instance_id
 * @property {boolean} location_enabled - is location enabled
 * @return {LogObject<oaEventDetailsSettingsSavedParams>} LogObject<oaEventDetailsSettingsSavedParams>
 */
export function oaEventDetailsSettingsSaved(params) {
    return { evid: 260, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaCustomizeDisplayEvents' event (evid: 261)
 *
 * Event description: User clicks either on "Customize the Event Details Page" in event list settings, "Event Details Page" in OA Events BO, or "Customize Sections" in Events Details Page settings.
 *
 * @param {oaCustomizeDisplayEventsParams} params - The parameters for this event
 * @property {string} origin - Where the button was clicked from, e.g. 'Edit Event', 'Events', 'Events Details Page'
 * @property {GUID} instance_id - instance_id
 * @property {string} action - 'customize event details', 'customize events list'
 * @return {LogObject<oaCustomizeDisplayEventsParams>} LogObject<oaCustomizeDisplayEventsParams>
 */
export function oaCustomizeDisplayEvents(params) {
    return { evid: 261, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaMyEventsFiltersApply' event (evid: 262)
 *
 * Event description: User selects published events list filters and clicks on apply. Also records which filters have been changed into which state.
 *
 * @param {oaMyEventsFiltersApplyParams} params - The parameters for this event
 * @property {boolean} is_category_selected - Whether user chose to filter by one of categories
 * @property {string} status_sort_value - Event date, Last modified
 * @property {string} origin - Describes from which OA page filter was used - Published, Draft, Recurring
 * @property {GUID} instance_id - instance_id
 * @property {string} type_filter_value - All, Single, Recurring
 * @property {string} status_filter_value - All, Upcoming, Canceled, Past
 * @return {LogObject<oaMyEventsFiltersApplyParams>} LogObject<oaMyEventsFiltersApplyParams>
 */
export function oaMyEventsFiltersApply(params) {
    return { evid: 262, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaMyEventsSearch' event (evid: 263)
 *
 * Event description: User uses search feature in published or draft events in OA.
 *
 * @param {oaMyEventsSearchParams} params - The parameters for this event
 * @property {string} origin - published, draft
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaMyEventsSearchParams>} LogObject<oaMyEventsSearchParams>
 */
export function oaMyEventsSearch(params) {
    return { evid: 263, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaGuestListFiltersSave' event (evid: 264)
 *
 * Event description: When user filters and/or sorts guest list in OA and cllicks 'save'
 *
 * @param {oaGuestListFiltersSaveParams} params - The parameters for this event
 * @property {number} ticket_type_filter_selected_count - Count of selected ticket types
 * @property {string} sort_type - A-Z, Z-A
 * @property {boolean} ticket_type_filter_is_all_selected - If 'All tickets' filter on - True, else - False
 * @property {GUID} instance_id - instance_id
 * @property {string} status_filter_value - E.g. all guests, paid, free, checked-in
 * @return {LogObject<oaGuestListFiltersSaveParams>} LogObject<oaGuestListFiltersSaveParams>
 */
export function oaGuestListFiltersSave(params) {
    return { evid: 264, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaScanCheckinFilterSave' event (evid: 265)
 *
 * Event description: User chooses, which ticket types will be able to be scanned.
 *
 * @param {oaScanCheckinFilterSaveParams} params - The parameters for this event
 * @property {number} ticket_type_filter_selected_count - Count of selected ticket types
 * @property {boolean} ticket_type_filter_is_all_selected - If 'All tickets' filter on - True, else - False
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaScanCheckinFilterSaveParams>} LogObject<oaScanCheckinFilterSaveParams>
 */
export function oaScanCheckinFilterSave(params) {
    return { evid: 265, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaGuestListOpened' event (evid: 266)
 *
 * Event description: User opens guest list from one of the available entry points
 *
 * @param {oaGuestListOpenedParams} params - The parameters for this event
 * @property {string} event_guid - event_guid
 * @property {string} origin - from where guest list was opened
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaGuestListOpenedParams>} LogObject<oaGuestListOpenedParams>
 */
export function oaGuestListOpened(params) {
    return { evid: 266, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'introAddonFeaturesSelected' event (evid: 267)
 *
 * Event description: user chose features that he wanted to add
 *
 * @param {introAddonFeaturesSelectedParams} params - The parameters for this event
 * @property {string} selected_features - list of features selected
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<introAddonFeaturesSelectedParams>} LogObject<introAddonFeaturesSelectedParams>
 */
export function introAddonFeaturesSelected(params) {
    return { evid: 267, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardNavigation' event (evid: 268)
 *
 * Event description: User clicks one of the available buttons inside an event's dashboard that will navigate them to a different  route
 *
 * @param {dashboardNavigationParams} params - The parameters for this event
 * @property {string} role - role
 * @property {GUID} staff_member_id - staff_member_id
 * @property {string} entity_type - relevant entity type: ticket, policy, schedule item, etc.
 * @property {string} entity_id - relevant entity id
 * @property {string} origin - the button clicked that incentivize the navigation
 * @property {string} target_page - the page to which the user is navigating
 * @property {boolean} is_external - Is the source or target pages outside the events dashboard
 * @property {string} source_page - the page from which the user is navigating
 * @property {GUID} event_id - event guid
 * @property {GUID} instance_id - instance_id
 * @property {string} additional_info - additional_info
 * @return {LogObject<dashboardNavigationParams>} LogObject<dashboardNavigationParams>
 */
export function dashboardNavigation(params) {
    return { evid: 268, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dashboardButtonClick' event (evid: 269)
 *
 * Event description: User clicks one of the available actions in an event's dashboard
 *
 * @param {dashboardButtonClickParams} params - The parameters for this event
 * @property {string} role - role
 * @property {GUID} staff_member_id - staff_member_id
 * @property {string} entity_type - relevant entity type: ticket, policy, schedule item, etc.
 * @property {string} entity_id - relevant entity id
 * @property {string} origin - button clicked
 * @property {string} source_page - route in which the click is taking place
 * @property {GUID} event_id - event guid
 * @property {GUID} instance_id - instance_id
 * @property {string} value - value
 * @return {LogObject<dashboardButtonClickParams>} LogObject<dashboardButtonClickParams>
 */
export function dashboardButtonClick(params) {
    return { evid: 269, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerAppGuestsCheckinSync' event (evid: 270)
 *
 * Event description: User sync checkins in owners app. Fires for each event that was synced
 *
 * @param {ownerAppGuestsCheckinSyncParams} params - The parameters for this event
 * @property {number} users_checked_in - number of users that got checked in
 * @property {GUID} event_id - event guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<ownerAppGuestsCheckinSyncParams>} LogObject<ownerAppGuestsCheckinSyncParams>
 */
export function ownerAppGuestsCheckinSync(params) {
    return { evid: 270, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ownerAppCarouselUsed' event (evid: 271)
 *
 * Event description: User uses one of the carousels in OA for the 1st time during a session
 *
 * @param {ownerAppCarouselUsedParams} params - The parameters for this event
 * @property {string} name - name of the carousel used, should be unique to identify among other carousels
 * @property {string} source_page - location of the carousel
 * @property {GUID} event_id - event guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<ownerAppCarouselUsedParams>} LogObject<ownerAppCarouselUsedParams>
 */
export function ownerAppCarouselUsed(params) {
    return { evid: 271, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createSeatingMapSuccess' event (evid: 272)
 *
 * Event description: Fired when creating seating map. Goal of this event is to identify seating map template used for map.
 *
 * @param {createSeatingMapSuccessParams} params - The parameters for this event
 * @property {GUID} seating_map_guid - seating_map_guid
 * @property {string} seating_map_template_key - template name
 * @property {GUID} original_seating_map_guid - seating_map_guid of the copied id. If from template then null
 * @property {GUID} event_id - event_guid
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<createSeatingMapSuccessParams>} LogObject<createSeatingMapSuccessParams>
 */
export function createSeatingMapSuccess(params) {
    return { evid: 272, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pagesModalPageOpenClick' event (evid: 273)
 *
 * Event description: User clicks on a link within pages modal in Events widgets.
 *
 * @param {pagesModalPageOpenClickParams} params - The parameters for this event
 * @property {string} widget_type - Event details/Events widget
 * @property {string} page_name - Events details page, registration form page, schedule page.
 * @property {string} editor_working_mode - desktop/mobile
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<pagesModalPageOpenClickParams>} LogObject<pagesModalPageOpenClickParams>
 */
export function pagesModalPageOpenClick(params) {
    return { evid: 273, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'staffMemberScanResult' event (evid: 274)
 *
 * Event description: Two ways to trigger this - one when the new staff member opens the link/qr code in browser, other way is when he scans from the app.
 *
 * @param {staffMemberScanResultParams} params - The parameters for this event
 * @property {string} result_type - result of the scan
 * @property {string} origin - origin
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<staffMemberScanResultParams>} LogObject<staffMemberScanResultParams>
 */
export function staffMemberScanResult(params) {
    return { evid: 274, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixAppAnyScreenOpened' event (evid: 275)
 *
 * Event description: Any screen opened in the app
 *
 * @param {wixAppAnyScreenOpenedParams} params - The parameters for this event
 * @property {GUID} staff_member_id - staff member id
 * @property {string} screen - {wix.events.EventDashboard, wix.events.EventStats, etc}
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<wixAppAnyScreenOpenedParams>} LogObject<wixAppAnyScreenOpenedParams>
 */
export function wixAppAnyScreenOpened(params) {
    return { evid: 275, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'feesEnforcementAcceptedSrc68Evid3' event (evid: 3)
 *
 * Event description: Fees enforcement accepted
 *
 *
 * @param {feesEnforcementAcceptedSrc68Evid3Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<feesEnforcementAcceptedSrc68Evid3Params>} LogObject<feesEnforcementAcceptedSrc68Evid3Params>
 */
export function feesEnforcementAcceptedSrc68Evid3(params) {
    return { evid: 3, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reportsAuditBiEventSrc68Evid4' event (evid: 4)
 *
 * Event description: ReportsAuditBiEvent
 *
 * @param {reportsAuditBiEventSrc68Evid4Params} params - The parameters for this event
 * @property {string} subject - subject
 * @property {GUID} eventId - eventId
 * @property {string} emailId - emailId
 * @property {boolean} isUnsubscribed - isUnsubscribed
 * @property {boolean} isEnabled - isEnabled
 * @property {boolean} isDailySummary - isDailySummary
 * @property {boolean} isInstantNotification - isInstantNotification
 * @property {string} emailTemplate - emailTemplate
 * @property {DateTime} sendDate - sendDate
 * @property {string} error - error
 * @property {string} details - details
 * @return {LogObject<reportsAuditBiEventSrc68Evid4Params>} LogObject<reportsAuditBiEventSrc68Evid4Params>
 */
export function reportsAuditBiEventSrc68Evid4(params) {
    return { evid: 4, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaEventsSectionOpened' event (evid: 43)
 *
 * Event description: event section opened
 *
 * @param {oaEventsSectionOpenedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} filter - {all, upcoming events, past, cancelled}
 * @property {string} comp_id - comp_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaEventsSectionOpenedParams>} LogObject<oaEventsSectionOpenedParams>
 */
export function oaEventsSectionOpened(params) {
    return { evid: 43, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaManageGuestsOpened' event (evid: 45)
 *
 * Event description: guest list opened successfully
 *
 * @param {oaManageGuestsOpenedParams} params - The parameters for this event
 * @property {string} filter - {all guests, paid, free, not paid, arrived, not arrived}
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaManageGuestsOpenedParams>} LogObject<oaManageGuestsOpenedParams>
 */
export function oaManageGuestsOpened(params) {
    return { evid: 45, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaOrderDetailsOpened' event (evid: 46)
 *
 * Event description: order (guest) page opened
 *
 * @param {oaOrderDetailsOpenedParams} params - The parameters for this event
 * @property {string} order_id - order_id
 * @property {string} tabName - orders/guest_list
 * @property {string} origin - previous location - {scanner,manage guests}
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaOrderDetailsOpenedParams>} LogObject<oaOrderDetailsOpenedParams>
 */
export function oaOrderDetailsOpened(params) {
    return { evid: 46, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaActionButtonClicked' event (evid: 47)
 *
 * Event description: action button clicked for guest
 *
 * @param {oaActionButtonClickedParams} params - The parameters for this event
 * @property {string} order_id - order_id
 * @property {string} tabName - orders/guest_list
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @property {string} action_type - {resend ticket, remove guest, check-in, mark as paid, view_tickets}
 * @return {LogObject<oaActionButtonClickedParams>} LogObject<oaActionButtonClickedParams>
 */
export function oaActionButtonClicked(params) {
    return { evid: 47, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaGuestPaidPopUpChoice' event (evid: 48)
 *
 * Event description: user's choice in the 'Guest Paid?' pop up
 *
 * @param {oaGuestPaidPopUpChoiceParams} params - The parameters for this event
 * @property {string} order_id - order_id
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @property {string} action_type - chose {ok, cancel}
 * @return {LogObject<oaGuestPaidPopUpChoiceParams>} LogObject<oaGuestPaidPopUpChoiceParams>
 */
export function oaGuestPaidPopUpChoice(params) {
    return { evid: 48, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uoULivesiteActionClickSrc68Evid5' event (evid: 5)
 *
 * Event description: UoU clicks in live site.
 *
 * @param {uoULivesiteActionClickSrc68Evid5Params} params - The parameters for this event
 * @property {string} role - role
 * @property {string} entity_type - relevant entity type: ticket, policy, schedule item, etc.
 * @property {string} entity_id - relevant entity id
 * @property {string} origin - button clicked
 * @property {string} target_page - the page to which the user is navigating
 * @property {string} source_page - route in which the click is taking place
 * @property {GUID} event_id - event guid
 * @return {LogObject<uoULivesiteActionClickSrc68Evid5Params>} LogObject<uoULivesiteActionClickSrc68Evid5Params>
 */
export function uoULivesiteActionClickSrc68Evid5(params) {
    return { evid: 5, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouOpenRegFormPopupClick' event (evid: 503)
 *
 * Event description: click on opening reg form by UoU
 *
 * @param {uouOpenRegFormPopupClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} questions_count - questions_count (send null at this stage)
 * @property {GUID} visitor_id - visitor_id
 * @property {string} destination_type - pop_up form (the old one), page_form (hiding page, no ticket), page_details (with or w/out ticket)
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @return {LogObject<uouOpenRegFormPopupClickParams>} LogObject<uouOpenRegFormPopupClickParams>
 */
export function uouOpenRegFormPopupClick(params) {
    return { evid: 503, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouPageDetailsLoaded' event (evid: 507)
 *
 * Event description: opening page details loaded by UoU
 *
 * @param {uouPageDetailsLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} ticket_definition_count - null if no tickets allowed/shown
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} type_of_event - {'rsvp','ticketed'}
 * @property {number} event_rank - event_rank
 * @property {string} origin - members area/ event list
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} currency - currency
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @return {LogObject<uouPageDetailsLoadedParams>} LogObject<uouPageDetailsLoadedParams>
 */
export function uouPageDetailsLoaded(params) {
    return { evid: 507, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouPageDetailsRegisterClick' event (evid: 508)
 *
 * Event description: clicking on checkout (for ticketed events) or register now for the rest
 * by UoU
 *
 * @param {uouPageDetailsRegisterClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} ticket_definition_count - null if no tickets allowed (unique ticket_def_id)
 * @property {number} ticket_count - null if no tickets allowed (absolute number of item purchased)
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} type_of_event - {'rsvp','ticketed'}
 * @property {number} event_rank - event_rank
 * @property {number} nonfree_ticket_count - same as ticket_count, but for non-free tickets only
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} currency - currency (or null)
 * @property {string} comp_id - comp_id
 * @property {number} total_order_revenue - money amount (null if no ticket, 0 if free ticket was purchased)
 * @property {GUID} event_id - event_id
 * @property {boolean} is_member_only_event - t/f
 * @return {LogObject<uouPageDetailsRegisterClickParams>} LogObject<uouPageDetailsRegisterClickParams>
 */
export function uouPageDetailsRegisterClick(params) {
    return { evid: 508, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouFormPageLoaded' event (evid: 509)
 *
 * Event description: form page loaded by UoU
 *
 * @param {uouFormPageLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} ticket_definition_count - null if no tickets allowed (unique ticket_def_id)
 * @property {number} ticket_count - null if no tickets allowed (absolute number of item purchased)
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {number} nonfree_ticket_count - same as ticket_count, but for non-free tickets only
 * @property {string} origin - null if didn't came from details page, 'details page' otherwise
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} currency - currency (or null)
 * @property {string} comp_id - comp_id
 * @property {number} total_order_revenue - money amount (null if no ticket, 0 if free ticket was purchased)
 * @property {GUID} event_id - event_id
 * @return {LogObject<uouFormPageLoadedParams>} LogObject<uouFormPageLoadedParams>
 */
export function uouFormPageLoaded(params) {
    return { evid: 509, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaQrScannerClicked' event (evid: 51)
 *
 * Event description: user clicked on the QR scanner to check in guests
 *
 * @param {oaQrScannerClickedParams} params - The parameters for this event
 * @property {number} ticket_type_filter_selected_count - Count of selected ticket types
 * @property {string} origin - {main scan cta, scanner, scan icon}
 * @property {boolean} ticket_type_filter_is_all_selected - If 'All tickets' filter on - True, else - False
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaQrScannerClickedParams>} LogObject<oaQrScannerClickedParams>
 */
export function oaQrScannerClicked(params) {
    return { evid: 51, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouFormPageSubmitClick' event (evid: 510)
 *
 * Event description: form page submit click by UoU:
 * button_name = 'submit' when no paid tickets are involved
 * button_name = 'chose_payment' when to cashier component
 *
 * @param {uouFormPageSubmitClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} ticket_definition_count - null if no tickets allowed (unique ticket_def_id)
 * @property {number} ticket_count - null if no tickets allowed (absolute number of item purchased)
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} button_name - submit, choose payment
 * @property {number} event_rank - event_rank
 * @property {number} nonfree_ticket_count - same as ticket_count, but for non-free tickets only
 * @property {number} visitor_rsvp_count - (null if ticketed) 1 is the visitor have responded for himself, 2 or more if the user choose "plus one" option
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} currency - currency (or null)
 * @property {string} comp_id - comp_id
 * @property {number} total_order_revenue - money amount (null if no ticket, 0 if free ticket was purchased)
 * @property {GUID} event_id - event_id
 * @property {string} rsvp_type - (null if ticketed) {'yes', 'no', 'maybe' etc)
 * @return {LogObject<uouFormPageSubmitClickParams>} LogObject<uouFormPageSubmitClickParams>
 */
export function uouFormPageSubmitClick(params) {
    return { evid: 510, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouTicketedThankyouPageLoaded' event (evid: 511)
 *
 * Event description: Thanks you page (ticketed version only) loaded for UoU with 4 state:
 * error, cancelled, pending, success
 *
 * @param {uouTicketedThankyouPageLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} ticket_definition_count - null if no tickets allowed (unique ticket_def_id)
 * @property {number} ticket_count - null if no tickets allowed (absolute number of item purchased)
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} paymentmethod - paymentmethod
 * @property {number} event_rank - event_rank
 * @property {number} nonfree_ticket_count - same as ticket_count, but for non-free tickets only
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} currency - currency (or null)
 * @property {string} comp_id - comp_id
 * @property {number} total_order_revenue - money amount (null if no ticket, 0 if free ticket was purchased)
 * @property {GUID} event_id - event_id
 * @property {string} page_type - error, cancelled, pending, success
 * @return {LogObject<uouTicketedThankyouPageLoadedParams>} LogObject<uouTicketedThankyouPageLoadedParams>
 */
export function uouTicketedThankyouPageLoaded(params) {
    return { evid: 511, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouNonticketedThankyouPageLoaded' event (evid: 512)
 *
 * Event description: Thanks you page (non-ticketed version only) loaded for UoU
 *
 * @param {uouNonticketedThankyouPageLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {number} visitor_rsvp_count - 1 is the visitor have respinded for himself, 2 or more if the user choose "plus one" option
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @property {string} rsvp_type - {'yes', 'no', 'maybe' etc)
 * @return {LogObject<uouNonticketedThankyouPageLoadedParams>} LogObject<uouNonticketedThankyouPageLoadedParams>
 */
export function uouNonticketedThankyouPageLoaded(params) {
    return { evid: 512, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouShareEventClick' event (evid: 513)
 *
 * Event description: uou_share_event_click
 *
 * @param {uouShareEventClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} button_name - {'facebook','twitter','linkedin', etc}
 * @property {number} event_rank - event_rank
 * @property {string} origin - widget, page details, (from thank you page -->) success, error etc
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @return {LogObject<uouShareEventClickParams>} LogObject<uouShareEventClickParams>
 */
export function uouShareEventClick(params) {
    return { evid: 513, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouClickedOnEnterCouponCode' event (evid: 514)
 *
 * Event description: uou clicked on 'enter coupon code'
 *
 * @param {uouClickedOnEnterCouponCodeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_id
 * @return {LogObject<uouClickedOnEnterCouponCodeParams>} LogObject<uouClickedOnEnterCouponCodeParams>
 */
export function uouClickedOnEnterCouponCode(params) {
    return { evid: 514, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouCouponCodeApplied' event (evid: 515)
 *
 * Event description: uou coupon code applied
 *
 * @param {uouCouponCodeAppliedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} comp_id - comp_id
 * @property {string} ticket_types - array of ticket ids from order
 * @property {GUID} event_id - event_id
 * @property {GUID} couponId - coupon_id
 * @return {LogObject<uouCouponCodeAppliedParams>} LogObject<uouCouponCodeAppliedParams>
 */
export function uouCouponCodeApplied(params) {
    return { evid: 515, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingsPricingOptionModalOpened' event (evid: 516)
 *
 * Event description: Modal for seatings pricing options selection.
 *
 * @param {seatingsPricingOptionModalOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} seat_guid - unique seat id, null if whole table reservation is required
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} pricing_options - json value for all pricing options
 * @property {number} event_rank - event_rank
 * @property {string} element_guid - element id
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {boolean} is_whole_table - true if the selected element required whole table reservation
 * @property {string} element_type - element type
 * @property {GUID} event_id - event_guid
 * @property {GUID} msid - msid
 * @property {GUID} ticket_definition_id - ticket_definition_id
 * @return {LogObject<seatingsPricingOptionModalOpenedParams>} LogObject<seatingsPricingOptionModalOpenedParams>
 */
export function seatingsPricingOptionModalOpened(params) {
    return { evid: 516, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'seatingsPricingOptionModalSelected' event (evid: 517)
 *
 * Event description: UoU modal selection - Cancel (or X button), Add to basket
 *
 * @param {seatingsPricingOptionModalSelectedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} seat_guid - unique seat id, null if whole table reservation is required
 * @property {GUID} visitorId - visitor_id
 * @property {GUID} biToken - msid
 * @property {string} selected_pricing_options - json value for selected pricing options
 * @property {GUID} visitor_id - visitor_id
 * @property {string} pricing_options - json value for all pricing options
 * @property {number} event_rank - event_rank
 * @property {string} element_guid - element id
 * @property {string} selection - {'Close','Add to basket'}
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {boolean} is_whole_table - true if the selected element required whole table reservation
 * @property {string} element_type - element type
 * @property {GUID} event_id - event_guid
 * @property {GUID} msid - msid
 * @property {GUID} ticket_definition_id - ticket_definition_id
 * @return {LogObject<seatingsPricingOptionModalSelectedParams>} LogObject<seatingsPricingOptionModalSelectedParams>
 */
export function seatingsPricingOptionModalSelected(params) {
    return { evid: 517, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouTicketsMorePricesClick' event (evid: 518)
 *
 * Event description: UoU clicks on the More Prices + accordion available in the View Tickets window when a ticket has more than one price option available
 *
 * @param {uouTicketsMorePricesClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {GUID} event_id - event guid
 * @property {GUID} ticket_definition_id - ticket id
 * @return {LogObject<uouTicketsMorePricesClickParams>} LogObject<uouTicketsMorePricesClickParams>
 */
export function uouTicketsMorePricesClick(params) {
    return { evid: 518, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaQrScannerResult' event (evid: 52)
 *
 * Event description: QR scanner result
 *
 * @param {oaQrScannerResultParams} params - The parameters for this event
 * @property {number} ticket_type_filter_selected_count - Count of selected ticket types
 * @property {string} ticket_id - ticket_id (the ticket number of the order)
 * @property {string} order_id - order_id
 * @property {string} role - []
 * @property {string} result_type - {success, wrong ticket, guest removed, hasn't paid}
 * @property {boolean} ticket_type_filter_is_all_selected - If 'All tickets' filter on - True, else - False
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @property {GUID} staff_member_id - staff_member_id
 * @return {LogObject<oaQrScannerResultParams>} LogObject<oaQrScannerResultParams>
 */
export function oaQrScannerResult(params) {
    return { evid: 52, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaGuestStatusChangedManually' event (evid: 53)
 *
 * Event description: guest status changed manually on the Web or OA
 *
 * @param {oaGuestStatusChangedManuallyParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {string} order_id - order_id
 * @property {string} role - []
 * @property {GUID} rsvp_id - rsvp_id
 * @property {number} guestIndex - guest index
 * @property {string} type - {rsvp,ticket}
 * @property {boolean} arrived - arrived - True, not arrived - False
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @property {GUID} staff_member_id - staff_member_id
 * @return {LogObject<oaGuestStatusChangedManuallyParams>} LogObject<oaGuestStatusChangedManuallyParams>
 */
export function oaGuestStatusChangedManually(params) {
    return { evid: 53, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaGuestSearch' event (evid: 54)
 *
 * Event description: user searched for guest name/ ticket in 'Check-Ins' page
 *
 * @param {oaGuestSearchParams} params - The parameters for this event
 * @property {string} tabName - orders/guest list
 * @property {string} search_term - search term
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaGuestSearchParams>} LogObject<oaGuestSearchParams>
 */
export function oaGuestSearch(params) {
    return { evid: 54, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaEventActionButtonClicked' event (evid: 55)
 *
 * Event description: Any clicks in the wix apps
 *
 * @param {oaEventActionButtonClickedParams} params - The parameters for this event
 * @property {string} role - role
 * @property {GUID} staff_member_id - staff member id
 * @property {string} screen - screen from which the action was made
 * @property {GUID} event_id - Event guid if the action is done on specific event level
 * @property {GUID} instance_id - instance_id
 * @property {string} action - {'manage guests','edit event info,' 'share event'} or any other action
 * @return {LogObject<oaEventActionButtonClickedParams>} LogObject<oaEventActionButtonClickedParams>
 */
export function oaEventActionButtonClicked(params) {
    return { evid: 55, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uoULivesiteActionClickCopySrc68Evid555' event (evid: 555)
 *
 * Event description: UoU clicks in live site.
 *
 * @param {uoULivesiteActionClickCopySrc68Evid555Params} params - The parameters for this event
 * @property {string} role - role
 * @property {string} entity_type - relevant entity type: ticket, policy, schedule item, etc.
 * @property {string} entity_id - relevant entity id
 * @property {string} origin - button clicked
 * @property {string} target_page - the page to which the user is navigating
 * @property {string} source_page - route in which the click is taking place
 * @property {GUID} event_id - event guid
 * @return {LogObject<uoULivesiteActionClickCopySrc68Evid555Params>} LogObject<uoULivesiteActionClickCopySrc68Evid555Params>
 */
export function uoULivesiteActionClickCopySrc68Evid555(params) {
    return { evid: 555, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouAddToCalendarClickCopySrc68Evid556' event (evid: 556)
 *
 * Event description: UoU clicks in live site.
 *
 * @param {uouAddToCalendarClickCopySrc68Evid556Params} params - The parameters for this event
 * @return {LogObject<uouAddToCalendarClickCopySrc68Evid556Params>} LogObject<uouAddToCalendarClickCopySrc68Evid556Params>
 */
export function uouAddToCalendarClickCopySrc68Evid556(params) {
    return { evid: 556, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaShareEventClick' event (evid: 56)
 *
 * Event description: sent when member/user shares event
 *
 * @param {oaShareEventClickParams} params - The parameters for this event
 * @property {string} type_of_event - {'rsvp', 'ticketed'}
 * @property {string} origin - {}
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaShareEventClickParams>} LogObject<oaShareEventClickParams>
 */
export function oaShareEventClick(params) {
    return { evid: 56, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaInviteGuestsClick' event (evid: 57)
 *
 * Event description: sent when user clicks 'invite guests' in order to manually add guests to his event
 *
 * @param {oaInviteGuestsClickParams} params - The parameters for this event
 * @property {string} type_of_event - ticketed/rsvp
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaInviteGuestsClickParams>} LogObject<oaInviteGuestsClickParams>
 */
export function oaInviteGuestsClick(params) {
    return { evid: 57, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaMembersGoingClick' event (evid: 58)
 *
 * Event description: sent when user/member clicks on members going in order to see who is going to the event
 *
 * @param {oaMembersGoingClickParams} params - The parameters for this event
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaMembersGoingClickParams>} LogObject<oaMembersGoingClickParams>
 */
export function oaMembersGoingClick(params) {
    return { evid: 58, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaRsvpClick' event (evid: 59)
 *
 * Event description: sent when member clicks on RSVP
 *
 * @param {oaRsvpClickParams} params - The parameters for this event
 * @property {string} origin - {card, event details}
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaRsvpClickParams>} LogObject<oaRsvpClickParams>
 */
export function oaRsvpClick(params) {
    return { evid: 59, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uoUErrorInLivesiteSrc68Evid6' event (evid: 6)
 *
 * Event description: BI event fires when something bad happens (error, bug and etc.)
 *
 * @param {uoUErrorInLivesiteSrc68Evid6Params} params - The parameters for this event
 * @property {string} role - role
 * @property {string} entity_type - relevant entity type: ticket, policy, schedule item, etc.
 * @property {string} entity_id - relevant entity id
 * @property {string} origin - button clicked
 * @property {string} target_page - the page to which the user is navigating
 * @property {string} source_page - route in which the click is taking place
 * @property {GUID} event_id - event guid
 * @property {string} error_message - error message
 * @return {LogObject<uoUErrorInLivesiteSrc68Evid6Params>} LogObject<uoUErrorInLivesiteSrc68Evid6Params>
 */
export function uoUErrorInLivesiteSrc68Evid6(params) {
    return { evid: 6, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaBuyTicketClick' event (evid: 60)
 *
 * Event description: sent when member clicks on 'buy ticket'. IOS exception cases receive 'request tickets' button.
 *
 * @param {oaBuyTicketClickParams} params - The parameters for this event
 * @property {string} button_name - {'buy ticket','request tickets','sell_tickets_in_person'}
 * @property {string} origin - {'member_view','point_of_sale'}
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaBuyTicketClickParams>} LogObject<oaBuyTicketClickParams>
 */
export function oaBuyTicketClick(params) {
    return { evid: 60, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaRsvpSuccessScreenChoice' event (evid: 61)
 *
 * Event description: sent when a member chooses one of the options in the RSVP success screen
 *
 * @param {oaRsvpSuccessScreenChoiceParams} params - The parameters for this event
 * @property {string} choice - {leave, add to calendar, see more events}
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaRsvpSuccessScreenChoiceParams>} LogObject<oaRsvpSuccessScreenChoiceParams>
 */
export function oaRsvpSuccessScreenChoice(params) {
    return { evid: 61, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaTicketSuccessScreenChoice' event (evid: 62)
 *
 * Event description: sent when a member chooses one of the options in the ticket success screen. UoU action
 *
 * @param {oaTicketSuccessScreenChoiceParams} params - The parameters for this event
 * @property {string} choice - {leave, add to calendar, check order info}
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaTicketSuccessScreenChoiceParams>} LogObject<oaTicketSuccessScreenChoiceParams>
 */
export function oaTicketSuccessScreenChoice(params) {
    return { evid: 62, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaMemberClickedSubmitInTicketForm' event (evid: 63)
 *
 * Event description: sent when a member clicks 'submit' in the purchase ticket form
 *
 * @param {oaMemberClickedSubmitInTicketFormParams} params - The parameters for this event
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaMemberClickedSubmitInTicketFormParams>} LogObject<oaMemberClickedSubmitInTicketFormParams>
 */
export function oaMemberClickedSubmitInTicketForm(params) {
    return { evid: 63, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaEventCanceled' event (evid: 64)
 *
 * Event description: sent when a user chooses to cancel an event after pop-up
 *
 * @param {oaEventCanceledParams} params - The parameters for this event
 * @property {GUID} event_id - the selected event's guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaEventCanceledParams>} LogObject<oaEventCanceledParams>
 */
export function oaEventCanceled(params) {
    return { evid: 64, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createCouponClick' event (evid: 65)
 *
 * Event description: user clicked on create coupon
 *
 * @param {createCouponClickParams} params - The parameters for this event
 * @property {string} origin - {new ticket, edit ticket, ticket tab}
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<createCouponClickParams>} LogObject<createCouponClickParams>
 */
export function createCouponClick(params) {
    return { evid: 65, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hideRsvpButtonToggle' event (evid: 66)
 *
 * Event description: user chose to hide/unhide
 *
 * @param {hideRsvpButtonToggleParams} params - The parameters for this event
 * @property {string} buttonStatus - {hidden,visible}
 * @property {string} comp_id - comp_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<hideRsvpButtonToggleParams>} LogObject<hideRsvpButtonToggleParams>
 */
export function hideRsvpButtonToggle(params) {
    return { evid: 66, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'guestTabActionButtonClicked' event (evid: 67)
 *
 * Event description: sent for the choice of the action button click - not for the click itself (only sent for a certain option)
 *
 * @param {guestTabActionButtonClickedParams} params - The parameters for this event
 * @property {string} tabName - 'orders'/'guest_list'
 * @property {string} comp_id - comp_id
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @property {string} action - action {contact guests, refresh, export list}
 * @return {LogObject<guestTabActionButtonClickedParams>} LogObject<guestTabActionButtonClickedParams>
 */
export function guestTabActionButtonClicked(params) {
    return { evid: 67, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaEventSelectorChoice' event (evid: 68)
 *
 * Event description: sent when a user chooses whether to create an RSVP or tIcketed event ("decide later" is deprecated)
 *
 * @param {oaEventSelectorChoiceParams} params - The parameters for this event
 * @property {string} choice - {sell_tickets,rsvps,decide_later}
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaEventSelectorChoiceParams>} LogObject<oaEventSelectorChoiceParams>
 */
export function oaEventSelectorChoice(params) {
    return { evid: 68, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaTicketsToggle' event (evid: 70)
 *
 * Event description: sent when a user switches tickets toggle on/off
 *
 * @param {oaTicketsToggleParams} params - The parameters for this event
 * @property {string} choice - {on,off}
 * @property {GUID} event_id - event_guid
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaTicketsToggleParams>} LogObject<oaTicketsToggleParams>
 */
export function oaTicketsToggle(params) {
    return { evid: 70, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaClickOnConnectPaymentBanner' event (evid: 71)
 *
 * Event description: sent when a user clicks on connect payment button
 *
 * @param {oaClickOnConnectPaymentBannerParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaClickOnConnectPaymentBannerParams>} LogObject<oaClickOnConnectPaymentBannerParams>
 */
export function oaClickOnConnectPaymentBanner(params) {
    return { evid: 71, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaClickManageGuests' event (evid: 73)
 *
 * Event description: clicked manage guest
 *
 * @param {oaClickManageGuestsParams} params - The parameters for this event
 * @property {string} entryPoint - 'manage_guests'/'events_list' (for message)
 * @property {string} action_name - action name
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaClickManageGuestsParams>} LogObject<oaClickManageGuestsParams>
 */
export function oaClickManageGuests(params) {
    return { evid: 73, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'upgradeClick' event (evid: 74)
 *
 * Event description: user clicked upgrade button
 *
 * @param {upgradeClickParams} params - The parameters for this event
 * @property {string} origin - {'connect_payment','settings_panel','new_upgrade_screen','bizmgr','GFPPP_icon','conference_setup'
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<upgradeClickParams>} LogObject<upgradeClickParams>
 */
export function upgradeClick(params) {
    return { evid: 74, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaClickEventDetails' event (evid: 75)
 *
 * Event description: Owner/Member clicked an event's details - in member view
 *
 * @param {oaClickEventDetailsParams} params - The parameters for this event
 * @property {string} roles - member/owner
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaClickEventDetailsParams>} LogObject<oaClickEventDetailsParams>
 */
export function oaClickEventDetails(params) {
    return { evid: 75, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'copyOfOaOwnerUouActionPopup' event (evid: 77)
 *
 * Event description: Owner tried to buy ticket/rsvp to his own event and got popup, in member view
 *
 * @param {copyOfOaOwnerUouActionPopupParams} params - The parameters for this event
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance
 * @property {string} action - rsvp/buy ticket
 * @return {LogObject<copyOfOaOwnerUouActionPopupParams>} LogObject<copyOfOaOwnerUouActionPopupParams>
 */
export function copyOfOaOwnerUouActionPopup(params) {
    return { evid: 77, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaTicketScannerFlashlightClick' event (evid: 78)
 *
 * Event description: user clicked flashlight icon when trying to scan a ticket.
 *
 * @param {oaTicketScannerFlashlightClickParams} params - The parameters for this event
 * @property {GUID} event_id - event
 * @property {GUID} instance_id - instance
 * @return {LogObject<oaTicketScannerFlashlightClickParams>} LogObject<oaTicketScannerFlashlightClickParams>
 */
export function oaTicketScannerFlashlightClick(params) {
    return { evid: 78, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaClickEventDetailsNew' event (evid: 79)
 *
 * Event description: user clicked the event details on OA in member view
 *
 * @param {oaClickEventDetailsNewParams} params - The parameters for this event
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance
 * @return {LogObject<oaClickEventDetailsNewParams>} LogObject<oaClickEventDetailsNewParams>
 */
export function oaClickEventDetailsNew(params) {
    return { evid: 79, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixEventsWidgetLoaded' event (evid: 80)
 *
 * Event description: user/uou saw fully loaded events widget
 *
 * @param {wixEventsWidgetLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} display_type - multiple/single
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} narrow_layout - narrow_layout
 * @property {number} event_rank - event_rank
 * @property {boolean} has_image - t/f
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {boolean} is_main_page - true/false
 * @property {string} layout - grid/list/side by side/ calendar
 * @return {LogObject<wixEventsWidgetLoadedParams>} LogObject<wixEventsWidgetLoadedParams>
 */
export function wixEventsWidgetLoaded(params) {
    return { evid: 80, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaAddGuestManuallySubmit' event (evid: 82)
 *
 * Event description: owner submitted guest info and added him to event guest list
 *
 * @param {oaAddGuestManuallySubmitParams} params - The parameters for this event
 * @property {string} ticket_status - {'not_paid', 'paid', 'free'}
 * @property {string} guest_status - {'arrived', 'going'}
 * @property {string} type_of_event - ticketed/rsvp
 * @property {boolean} send_ticket_pdf - true / false
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaAddGuestManuallySubmitParams>} LogObject<oaAddGuestManuallySubmitParams>
 */
export function oaAddGuestManuallySubmit(params) {
    return { evid: 82, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaMembersGoingOpened' event (evid: 83)
 *
 * Event description: when a user clicked to see the embers attending an event
 *
 * @param {oaMembersGoingOpenedParams} params - The parameters for this event
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaMembersGoingOpenedParams>} LogObject<oaMembersGoingOpenedParams>
 */
export function oaMembersGoingOpened(params) {
    return { evid: 83, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaEventDetailsPageView' event (evid: 84)
 *
 * Event description: user views event details page view
 *
 * @param {oaEventDetailsPageViewParams} params - The parameters for this event
 * @property {string} button_name - offered button for ticket purchase {'buy ticket','request tickets','rsvp'}
 * @property {string} origin - {}
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaEventDetailsPageViewParams>} LogObject<oaEventDetailsPageViewParams>
 */
export function oaEventDetailsPageView(params) {
    return { evid: 84, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'regGuestInfoToggleSave' event (evid: 86)
 *
 * Event description: user changed toggle and saved
 *
 * @param {regGuestInfoToggleSaveParams} params - The parameters for this event
 * @property {string} type - 'reg_per_order'/'reg_per_ticket'
 * @property {GUID} event_id - event id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<regGuestInfoToggleSaveParams>} LogObject<regGuestInfoToggleSaveParams>
 */
export function regGuestInfoToggleSave(params) {
    return { evid: 86, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouCancelRsvpClick' event (evid: 87)
 *
 * Event description: clicked on cancel rsvp
 *
 * @param {uouCancelRsvpClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor
 * @property {number} event_rank - event_rank
 * @property {string} origin - members area/thank you page
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} comp_id - comp
 * @property {GUID} event_id - event id
 * @return {LogObject<uouCancelRsvpClickParams>} LogObject<uouCancelRsvpClickParams>
 */
export function uouCancelRsvpClick(params) {
    return { evid: 87, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouDownloadTickets' event (evid: 88)
 *
 * Event description: clicked on download tickets
 *
 * @param {uouDownloadTicketsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor
 * @property {string} button_name - {'download_pdf', 'add_to_apple_wallet'}
 * @property {number} event_rank - event_rank
 * @property {string} origin - {'members area', 'thank you page'}
 * @property {boolean} show_image - show_image
 * @property {boolean} is_mobile - True if UoU is making the action from mobile web, else False. From 2021-03-29
 * @property {number} total_events_count - total_events_count
 * @property {string} comp_id - comp
 * @property {GUID} event_id - event
 * @return {LogObject<uouDownloadTicketsParams>} LogObject<uouDownloadTicketsParams>
 */
export function uouDownloadTickets(params) {
    return { evid: 88, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouSeeAllGuestsClick' event (evid: 89)
 *
 * Event description: clicked on see all guests from event details
 *
 * @param {uouSeeAllGuestsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor
 * @property {number} event_rank - event_rank
 * @property {boolean} show_image - show_image
 * @property {number} total_events_count - total_events_count
 * @property {string} comp_id - comp
 * @property {GUID} event_id - event
 * @return {LogObject<uouSeeAllGuestsClickParams>} LogObject<uouSeeAllGuestsClickParams>
 */
export function uouSeeAllGuestsClick(params) {
    return { evid: 89, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'membersEventsSettingsClick' event (evid: 90)
 *
 * Event description: user clicked on settings of members events tab in editor
 *
 * @param {membersEventsSettingsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance
 * @return {LogObject<membersEventsSettingsClickParams>} LogObject<membersEventsSettingsClickParams>
 */
export function membersEventsSettingsClick(params) {
    return { evid: 90, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouMemberCardClick' event (evid: 91)
 *
 * Event description: clicked on a member's card from guest list
 *
 * @param {uouMemberCardClickParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor
 * @property {string} member_id - member
 * @property {GUID} event_id - event
 * @property {GUID} instance_id - instance
 * @return {LogObject<uouMemberCardClickParams>} LogObject<uouMemberCardClickParams>
 */
export function uouMemberCardClick(params) {
    return { evid: 91, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createAutomationsClick' event (evid: 93)
 *
 * Event description: user clicked on create automation from emails tab in event
 *
 * @param {createAutomationsClickParams} params - The parameters for this event
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<createAutomationsClickParams>} LogObject<createAutomationsClickParams>
 */
export function createAutomationsClick(params) {
    return { evid: 93, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addEventsMembersAreaClick' event (evid: 94)
 *
 * Event description: user clicked add now (events to members area) in settings panel
 *
 * @param {addEventsMembersAreaClickParams} params - The parameters for this event
 * @property {string} addType - 'members_area'/'events_to_members_area'
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<addEventsMembersAreaClickParams>} LogObject<addEventsMembersAreaClickParams>
 */
export function addEventsMembersAreaClick(params) {
    return { evid: 94, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaSwitchBetweenGuestTabs' event (evid: 95)
 *
 * Event description: user moved between manage guest tabs
 *
 * @param {oaSwitchBetweenGuestTabsParams} params - The parameters for this event
 * @property {string} tabName - previous tab
 * @property {string} origin - {'OWNER_VIEW_LIST', 'NOTIFICATION'}
 * @property {string} targetTab - target tab
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaSwitchBetweenGuestTabsParams>} LogObject<oaSwitchBetweenGuestTabsParams>
 */
export function oaSwitchBetweenGuestTabs(params) {
    return { evid: 95, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'oaFilterAppliedToGuestList' event (evid: 96)
 *
 * Event description: applied filter
 *
 * @param {oaFilterAppliedToGuestListParams} params - The parameters for this event
 * @property {number} ticket_type_filter_selected_count - Count of selected ticket types
 * @property {string} filter - E.g. all guests, paid, free, checked-in
 * @property {string} sort_by - choice to sort by (A-Z, Z-A) etc.
 * @property {boolean} ticket_type_filter_is_all_selected - If 'All tickets' filter on - True, else - False
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<oaFilterAppliedToGuestListParams>} LogObject<oaFilterAppliedToGuestListParams>
 */
export function oaFilterAppliedToGuestList(params) {
    return { evid: 96, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'promotionClick' event (evid: 97)
 *
 * Event description: user clicked on a promotion in promote tab in OA
 *
 * @param {promotionClickParams} params - The parameters for this event
 * @property {string} origin - {'event_promotion','promote_quick_actions'}
 * @property {string} type - email_marketing/social_post
 * @property {GUID} event_id - event_id
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<promotionClickParams>} LogObject<promotionClickParams>
 */
export function promotionClick(params) {
    return { evid: 97, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketSettingsClickEdit' event (evid: 98)
 *
 * Event description: user clicked on edit ticket settings from ticket tab
 *
 * @param {ticketSettingsClickEditParams} params - The parameters for this event
 * @property {GUID} event_id - []
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<ticketSettingsClickEditParams>} LogObject<ticketSettingsClickEditParams>
 */
export function ticketSettingsClickEdit(params) {
    return { evid: 98, src: 68, endpoint: '', params };
}
/**
 * A function to create a log object for the 'ticketSettingsSave' event (evid: 99)
 *
 * Event description: user clicked save ticket settings
 *
 * @param {ticketSettingsSaveParams} params - The parameters for this event
 * @property {number} tax_rate - tax rate * 100
 * @property {number} ticket_limit - Ticket limit per order chosen
 * @property {string} tax_display - 'add_in_checkout'/'include_in_price'
 * @property {string} tax_name - tax name
 * @property {string} currency - currency chosen
 * @property {GUID} event_id - []
 * @property {GUID} instance_id - instance_id
 * @return {LogObject<ticketSettingsSaveParams>} LogObject<ticketSettingsSaveParams>
 */
export function ticketSettingsSave(params) {
    return { evid: 99, src: 68, endpoint: '', params };
}
//# sourceMappingURL=index.js.map